var _this = this;
import { __assign, __awaiter, __generator } from "tslib";
import React from 'react';
import loadable from '@loadable/component';
import styles from './FlowLogItemWrapper.module.less';
import { Popover, Avatar, Tooltip, Ellipsis, Popconfirm, Button, message, Divider } from '@hose/eui';
import { FilledGeneralRecord, FilledGeneralPosition, FilledGeneralIntelligentService, OutlinedEditDeleteTrash, OutlinedGeneralAttachment, OutlinedGeneralSignature1 } from '@hose/eui-icons';
import classNames from 'classnames';
import Highlighter from 'react-highlight-words';
import { fnFormatAttachment } from '@ekuaibao/lib/lib/lib-util';
import { comment2MentionContent, formatRegStr, containsMarkdownSyntax, isHtmlText } from './util/parse';
import { getMoney } from '../../../lib/misc';
import { skippedTypeMap, agreeType, printLogMap } from '@ekuaibao/lib/lib/enums';
import AttachmentList from '../../puppet/attachmentList/AttachmentList';
import { app as api } from '@ekuaibao/whispered';
import { get } from 'lodash';
import EkbIcon from '../../../elements/ekbIcon';
import { getDisplayName, getStaffShowByConfig, isPayNode, getStaffName as getStaffNameOfConfig } from './../../utilFn';
import Big from 'big.js';
import { isString } from '@ekuaibao/helpers';
import { CountersignTooltip } from '../../countersign/countersign-selector';
import CountersignAvatar from '../../countersign/countersign-avatar-config';
import { ConditionApporveTipView, PayeeInfoPopover } from './FlowPlanLog/FlowPlanViewHelper';
import { skipTypeMap } from '../../../lib/enums';
import moment from 'moment';
import { deleteComment } from '../../../plugins/bills/bills.action';
import { getBoolVariation, enableCommentRejectorOptimization } from '../../../lib/featbit';
import { getAIAgentObj, isAIAgentNode, getSkippedNodeStaff } from '../../ai-agent-utils';
import { NameCell } from '../../name-cell';
var HtmlCommentRenderer = loadable(function () { return import('./HtmlCommentRenderer'); });
var download = api.invokeServiceAsLazyValue('@bills:file:download');
export var ModifyCreateType = 'CREATE';
var ModifyBillAction = 'freeflow.modify';
var emptyStr = '';
var EBotName = 'Ebot';
var preview = api.invokeServiceAsLazyValue('@bills:file:preview');
var lastVersionNum = 0;
export function fnFilePreview(attachmentsData, clickItem) {
    preview()({ value: attachmentsData, line: clickItem });
}
function fnFileDownload(line) {
    download()(line);
}
var formatAttachments = function (attachments) {
    var items = fnFormatAttachment(attachments);
    return {
        length: items.length,
        attachmentsContent: (React.createElement(AttachmentList, { onFilePreview: fnFilePreview.bind(_this, items), onFileDownload: fnFileDownload, fileList: items })),
        label: i18n.get('附件')
    };
};
export function renderCommentWithMarkdown(comment, element, options) {
    if (options === void 0) { options = {}; }
    try {
        if (getBoolVariation('ao-161-comment-support-richeditor-show') && isHtmlText(comment)) {
            return React.createElement(HtmlCommentRenderer, { comment: comment });
        }
        var isRisk = (options === null || options === void 0 ? void 0 : options.type) === 'risk';
        if (isRisk) {
            if (!getBoolVariation('ao-46-bill-risk-markdown') || isHtmlText(comment)) {
                return element;
            }
        }
        else {
            if (!getBoolVariation('ao-46-markdown-render') || isHtmlText(comment)) {
                return element;
            }
        }
        return containsMarkdownSyntax(comment, isRisk) ? (React.createElement(HtmlCommentRenderer, { comment: comment, mode: isRisk ? 'risk' : 'markdown' })) : (element);
    }
    catch (error) {
        return element;
    }
}
export var renderComment = function (item) {
    var _a = item.attributes, _b = _a.participants, participants = _b === void 0 ? [] : _b, comment = _a.comment;
    participants = participants ? participants : [];
    var com = comment2MentionContent(comment, participants, flowStateMap.staffDisplayConfigField);
    var highlighterWords = participants.map(function (item) { return " @" + item.name + " "; });
    highlighterWords = parseReg(highlighterWords);
    var element = (React.createElement(Highlighter, { highlightClassName: styles['highlight'], searchWords: highlighterWords, textToHighlight: com }));
    return renderCommentWithMarkdown(com, element);
};
export var renderAttachments = function (attachments, props) {
    if (props === void 0) { props = {}; }
    var data = formatAttachments(attachments);
    return (React.createElement(Popover, { title: data.label, content: data.attachmentsContent, placement: props.placement },
        React.createElement("div", { className: classNames(styles['attachment-wrapper'], props.className, 'cur-p mr-8') },
            React.createElement(OutlinedGeneralAttachment, { fontSize: 12, className: "mr-4" }),
            i18n.get("{__k0} \u4E2A{__k1}", { __k0: data.length, __k1: data.label }))));
};
export var AutographImage = React.memo(function (props) {
    var autographImageId = props.autographImageId;
    var style = { width: 204, height: 115, borderRadius: 4 };
    var content = React.createElement("img", { style: style, src: autographImageId.url, alt: i18n.get('电子签名') });
    return (React.createElement(Popover, { placement: "bottomLeft", content: content },
        React.createElement("div", { className: classNames(styles['attachment-wrapper'], 'cur-p', 'mr-8') },
            React.createElement(OutlinedGeneralSignature1, { fontSize: 12, className: "mr-4" }),
            i18n.get('签名'))));
});
var renderVersion = function (item, click) {
    var action = function () {
        click && click(item);
    };
    var versionConfig = api.getState('@common.specificationVersionConfig');
    if (versionConfig && versionConfig.hideVersion) {
        return null;
    }
    return (React.createElement("div", { className: styles['version-wrapper'], onClick: action }, i18n.get('查看')));
};
var renderAvatar = function (avatar, className) {
    if (className === void 0) { className = ''; }
    if (Array.isArray(avatar)) {
        return (React.createElement("div", { className: classNames(styles['avatar-imgs']) },
            React.createElement(CountersignAvatar, { imageList: avatar })));
    }
    if (avatar === 'EBotIconNode') {
        return (React.createElement("div", { className: styles['user-icon'] + " " + className },
            React.createElement(FilledGeneralIntelligentService, { fontSize: 12, color: 'var(--eui-bg-body)' })));
    }
    if (avatar === 'RecalculateIconNode') {
        return React.createElement(EkbIcon, { name: "#EDico-sys-recount", className: styles['user-img'] });
    }
    if (avatar === 'CarbonCopyIconNode') {
        return (React.createElement("div", { className: styles['user-icon'] + " " + styles['usr-icon-rotate-neu-300'] },
            React.createElement(FilledGeneralPosition, { fontSize: 10, color: 'var(--eui-bg-body)' })));
    }
    var src = avatar ? avatar : null;
    return React.createElement(Avatar, { size: "xmini", src: src, className: styles['user-img'] });
};
var renderApproveContent = function (_a, subDom) {
    var content = _a.content, deleteCommentIcon = _a.deleteCommentIcon, _b = _a.highlighterWords, highlighterWords = _b === void 0 ? null : _b, _c = _a.popoverContent, popoverContent = _c === void 0 ? [] : _c, _d = _a.comments, comments = _d === void 0 ? null : _d;
    if (subDom === void 0) { subDom = null; }
    var contentClassName = "" + styles['approve-content-wrapper'];
    return (React.createElement("div", { className: "" + styles['horizontal'] },
        popoverContent.length > 0 ? (React.createElement(Popover, { overlayClassName: styles['flow-log-item-popover'], content: popoverContent, trigger: "hover" },
            React.createElement("div", { className: classNames(contentClassName, { 'cur-p': !!popoverContent }, 'translate-ignore-class') },
                highlighterWords ? (React.createElement(Highlighter, { highlightClassName: styles['content-highlight'], searchWords: highlighterWords, textToHighlight: content })) : (React.createElement(React.Fragment, null,
                    content,
                    comments)),
                !!subDom && subDom))) : (React.createElement("div", { className: contentClassName },
            highlighterWords ? (React.createElement(Highlighter, { highlightClassName: styles['content-highlight'], searchWords: highlighterWords, textToHighlight: content })) : (React.createElement(React.Fragment, null,
                content,
                comments)),
            !!subDom && subDom)),
        deleteCommentIcon));
};
function fnGetName(item, staff) {
    if (staff === void 0) { staff = undefined; }
    var name = getNameWithoutDelegate(item, staff);
    var byDelegateName = (item === null || item === void 0 ? void 0 : item.byDelegateId) ? getStaffShowByConfig(item === null || item === void 0 ? void 0 : item.byDelegateId) : '';
    name = byDelegateName ? i18n.get("{__k0}\u4EE3{__k1}", { __k0: byDelegateName, __k1: name }) : name;
    return name;
}
function getNameWithoutDelegate(item, staff) {
    if (staff === void 0) { staff = undefined; }
    var staffName = getStaffNameWithConfig(item, staff).staffName;
    return staffName;
}
function getStaffNameInfo(item, staff, useFullConfig) {
    if (staff === void 0) { staff = undefined; }
    if (useFullConfig === void 0) { useFullConfig = false; }
    var getStaffNameFunc = window.isInWeComISV
        ? function (item) { return React.createElement(NameCell, { type: "user", id: item.id, name: item.name }); }
        : useFullConfig
            ? getStaffShowByConfig
            : getStaffNameOfConfig;
    var staffName = '';
    if (staff) {
        staffName = getStaffNameFunc(staff);
    }
    else if (get(item, 'operatorId') === 'ebot') {
        staffName = get(item, 'operatorId');
    }
    else if (get(item, 'operatorId.isAIAgentNode')) {
        staffName = get(item, 'operatorId.name');
    }
    else {
        staffName = (item === null || item === void 0 ? void 0 : item.operatorId) ? getStaffNameFunc(item.operatorId) : '';
    }
    var byDelegateName = (item === null || item === void 0 ? void 0 : item.byDelegateId) ? getStaffNameFunc(item.byDelegateId) : '';
    return { staffName: staffName, byDelegateName: byDelegateName };
}
function getStaffName(item, staff) {
    if (staff === void 0) { staff = undefined; }
    return getStaffNameInfo(item, staff, false);
}
function getStaffNameWithConfig(item, staff) {
    if (staff === void 0) { staff = undefined; }
    return getStaffNameInfo(item, staff, true);
}
function addAtHighlighter(item, userInfo) {
    var _a = item.attributes, _b = _a.participants, participants = _b === void 0 ? [] : _b, comment = _a.comment;
    participants = participants ? participants : [];
    var isAtMe = userInfo && !!~participants.map(function (e) { return e.id; }).indexOf(userInfo.id);
    var content = comment2MentionContent(comment, participants, flowStateMap.staffDisplayConfigField);
    var highlighterWords = participants.map(function (item) { return " @" + item.name + " "; });
    highlighterWords = parseReg(highlighterWords);
    var atDom = isAtMe && (React.createElement("span", null,
        i18n.get('，'),
        i18n.get('并'),
        React.createElement("span", { className: styles['refer-me'] }, i18n.get('@我'))));
    return {
        atDom: atDom,
        content: content,
        highlighterWords: highlighterWords
    };
}
var UpdateApproverPopover = function (_a) {
    var name = _a.name, nodeName = _a.nodeName, oldOperatorAvatar = _a.oldOperatorAvatar, preName = _a.preName, nextOperatorAvatar = _a.nextOperatorAvatar, nextName = _a.nextName, children = _a.children, _b = _a.title, title = _b === void 0 ? i18n.get('重新指派审批人') : _b;
    return (React.createElement(Popover, { title: React.createElement("span", null,
            name,
            title), placement: 'bottom', content: React.createElement("div", { className: styles['flow-log-select-approver-wrapper'] },
            React.createElement("div", { className: "title" }, i18n.get('节点名称') + ":"),
            React.createElement("div", { className: "content" }, nodeName),
            React.createElement("div", { className: "title title-mt-16" }, i18n.get('审批人变更') + ":"),
            React.createElement("div", { className: "sub-title sub-title-mt-10" }, i18n.get('修改前')),
            React.createElement("div", { className: "content" }, preName ? (React.createElement(React.Fragment, null,
                renderAvatar(oldOperatorAvatar),
                React.createElement("span", { className: "ml-4" }, preName))) : (i18n.get('无'))),
            React.createElement("div", { className: "sub-title" }, i18n.get('修改后')),
            React.createElement("div", { className: "content" },
                renderAvatar(nextOperatorAvatar),
                React.createElement("span", { className: "ml-4" }, nextName))) }, children));
};
var showEBotSkippedTypes = [
    'NO_ABILITY',
    'NO_ABILITY_TRUE',
    'NO_ABILITY_FALSE',
    'REQUISITION_NO_ABILITY',
    'PAY_AMOUNT_IS_0',
    'PAY_AMOUNT_IS_0_TRUE',
    'PAY_AMOUNT_IS_0_FALSE',
    'APPROVER_NOT_FOUND',
    'APPROVER_NOT_FOUND_BY_ROLE'
];
var flowStateMap = {
    staffDisplayConfigField: '',
    retract: {
        approveContent: function (_a) {
            var item = _a.item;
            var name = getNameWithoutDelegate(item);
            var avatar = get(item, 'operatorId.avatar');
            var _b = getStaffName(item), staffName = _b.staffName, byDelegateName = _b.byDelegateName;
            var content = (React.createElement(Tooltip, { placement: 'bottom', title: formatToolTipContent(name, i18n.get('撤回了单据')) },
                React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-red'] },
                    renderAvatar(avatar),
                    React.createElement("div", { className: "text-container" },
                        React.createElement(StaffNameComponent, { staffName: byDelegateName || staffName, actionClassName: 'approve-content-wrapper-content-reject' }),
                        React.createElement("span", { className: "text-static approve-content-wrapper-content-reject flex-s-0 ml-4" }, i18n.get('撤回了单据'))))));
            return { content: content };
        },
        render: function (_a) {
            var item = _a.item;
            var content = this.approveContent({ item: item }).content;
            return renderApproveContent({ content: content });
        }
    },
    withdraw: {
        approveContent: function (_a) {
            var item = _a.item;
            var name = getNameWithoutDelegate(item);
            var avatar = get(item, 'operatorId.avatar');
            var _b = getStaffName(item), staffName = _b.staffName, byDelegateName = _b.byDelegateName;
            var content = (React.createElement(Tooltip, { placement: 'bottom', title: formatToolTipContent(name, i18n.get('撤回了单据')) },
                React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-red'] },
                    renderAvatar(avatar),
                    React.createElement("div", { className: "text-container" },
                        React.createElement(StaffNameComponent, { staffName: staffName, byDelegateName: byDelegateName, actionClassName: 'approve-content-wrapper-content-reject' }),
                        React.createElement("span", { className: "text-static approve-content-wrapper-content-reject flex-s-0 ml-4" }, i18n.get('撤回了单据'))))));
            return { content: content };
        },
        render: function (_a) {
            var item = _a.item;
            var content = this.approveContent({ item: item }).content;
            return renderApproveContent({ content: content });
        }
    },
    addnode: {
        approveContent: function (_a) {
            var item = _a.item;
            var nextOperatorId = item.nextOperatorId, _b = item.nextOperatorIds, nextOperatorIds = _b === void 0 ? [] : _b, _c = item.attributes, nodeName = _c.nextName, oldApproverId = _c.oldApproverId, isEbotNode = _c.isEbotNode;
            var name = fnGetName(item);
            var isShiftEbot = get(item, 'attributes.isShiftEbot');
            var nextNames = !!nextOperatorIds.length && getStaffShowByConfig(nextOperatorIds[0]);
            var nextStaffNames = !!nextOperatorIds.length && getStaffName({ operatorId: nextOperatorIds[0] }).staffName;
            var nextStaffDisplay = get(item, "nextOperatorId." + flowStateMap.staffDisplayConfigField);
            var nextStaffNameDisplay = getStaffName({ operatorId: get(item, "nextOperatorId") }).staffName;
            var nextOpName = getStaffShowByConfig(nextOperatorId);
            var nextOpStaffName = getStaffName(nextOperatorId).staffName;
            var avatar = get(item, 'operatorId.avatar');
            var nextOperatorAvatar = get(nextOperatorId, 'avatar');
            if (isEbotNode && !nextOperatorAvatar) {
                nextOperatorAvatar = 'EBotIconNode';
            }
            var nextName = isShiftEbot ? (EBotName) : nextNames ? (React.createElement(React.Fragment, null,
                nextNames,
                "\u7B49",
                nextOperatorIds.length,
                "\u4EBA")) : nextStaffDisplay ? (nextOpName + (" (" + nextStaffDisplay + ") ")) : (nextOpName);
            var nextOpStaffNameString = nextOpStaffName
                ? nextOpStaffName + (" (" + nextStaffNameDisplay + ") ")
                : nextStaffNameDisplay;
            var nextStaffName = isShiftEbot ? (EBotName) : nextStaffNames ? (React.createElement(React.Fragment, null,
                nextStaffNames,
                "\u7B49",
                nextOperatorIds.length,
                "\u4EBA")) : nextStaffNameDisplay ? (nextOpStaffNameString) : (nextOpStaffName);
            var addNodeType = get(item, 'attributes.addNodeType');
            var content = '';
            var transferNodeTypes = ['PRE_ADD_NODE', 'AFT_ADD_NODE', 'SHIFT_NODE', 'COMBINE_ADD_NODE'];
            if (transferNodeTypes.includes(addNodeType)) {
                var actionName = addNodeType === 'SHIFT_NODE' ? i18n.get('转交给') : i18n.get('加签给');
                var showActionName = actionName;
                var toolTipTitle = '';
                if (needTipContent(name) || needTipContent(nextName)) {
                    toolTipTitle = (React.createElement("span", null,
                        name,
                        " ",
                        actionName,
                        " ",
                        nextName));
                }
                var _d = getStaffName(item), staffName = _d.staffName, byDelegateName = _d.byDelegateName;
                var showNextName = true;
                if (byDelegateName) {
                    showNextName = false;
                    showActionName = addNodeType === 'SHIFT_NODE' ? i18n.get('转交') : i18n.get('加签');
                }
                content = (React.createElement(Tooltip, { placement: 'bottom', title: toolTipTitle },
                    React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-info-content'] },
                        renderAvatar(avatar, styles['usr-icon-info-500']),
                        React.createElement("div", { className: "text-container" },
                            React.createElement(StaffNameComponent, { staffName: staffName, byDelegateName: byDelegateName, actionClassName: 'approve-content-wrapper-content-info' }),
                            React.createElement("span", { className: "text-static approve-content-wrapper-content-info flex-s-0 ml-4 mr-4" }, showActionName),
                            showNextName ? React.createElement("span", { className: "text-ellipsis" }, nextStaffName) : null))));
            }
            else {
                var preName = getStaffShowByConfig(oldApproverId);
                var oldOperatorAvatar = get(oldApproverId, 'avatar');
                content = (React.createElement(UpdateApproverPopover, { name: name, nextName: nextName, nextOperatorAvatar: nextOperatorAvatar, oldOperatorAvatar: oldOperatorAvatar, nodeName: nodeName, preName: preName },
                    React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-gray'] + " cur-p" },
                        React.createElement("div", { className: "text-container" },
                            renderAvatar(avatar, styles['usr-icon-info-500']),
                            React.createElement("span", { className: "text-ellipsis" }, name),
                            React.createElement("span", { className: "text-static approve-content-wrapper-content-info ml-4" }, i18n.get('重新指派审批人'))))));
            }
            return { content: content };
        },
        render: function (_a) {
            var item = _a.item, userInfo = _a.userInfo;
            var _b = item.attributes, comment = _b.comment, autographImageId = _b.autographImageId, attachments = item.attachments;
            var content = this.approveContent({ item: item }).content;
            var hasAttachments = attachments && attachments.length > 0;
            var _c = addAtHighlighter(item, userInfo), atDom = _c.atDom, highlighterKey = _c.highlighterWords, commentContent = _c.content;
            var element = comment ? (React.createElement(Highlighter, { highlightClassName: styles['highlight'], searchWords: highlighterKey, textToHighlight: commentContent })) : (comment);
            return (React.createElement("div", { className: styles['content-wrapper'] },
                renderApproveContent({ content: content }, atDom),
                comment && (React.createElement("div", { className: styles['content-msg'] + " translate-ignore-class" }, renderCommentWithMarkdown(commentContent, element))),
                React.createElement("div", { className: "dis-f" },
                    hasAttachments && renderAttachments(attachments),
                    !!(autographImageId === null || autographImageId === void 0 ? void 0 : autographImageId.url) && React.createElement(AutographImage, { autographImageId: autographImageId }))));
        }
    },
    print: {
        approveContent: function (_a) {
            var item = _a.item;
            var _b = item.attributes, action = _b.action, autoRemind = _b.autoRemind;
            var name = fnGetName(item);
            var state = autoRemind ? 'autoRemind' : action;
            var avatar = get(item, 'operatorId.avatar');
            var msg = printLogMap('')[state];
            var _c = getStaffName(item), staffName = _c.staffName, byDelegateName = _c.byDelegateName;
            var avatarClassName = '';
            if (state === 'autoRemind') {
                avatar = 'EBotIconNode';
                staffName = EBotName;
                name = staffName;
                avatarClassName = styles['usr-icon-neu-400'];
                msg = i18n.get('自动提醒打印单据');
            }
            var content = (React.createElement(Tooltip, { placement: 'bottom', title: formatToolTipContent(name, msg) },
                React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-gray'] },
                    renderAvatar(avatar, avatarClassName),
                    React.createElement("div", { className: "text-container" },
                        React.createElement(StaffNameComponent, { staffName: byDelegateName || staffName, actionClassName: 'approve-content-wrapper-content' }),
                        React.createElement("span", { className: "text-static approve-content-wrapper-content flex-s-0 ml-4" }, msg)))));
            return { content: content };
        },
        render: function (_a) {
            var item = _a.item;
            var content = this.approveContent({ item: item }).content;
            return renderApproveContent({ content: content });
        }
    },
    submit: {
        approveContent: function (_a) {
            var item = _a.item;
            var attributes = item.attributes;
            var resubmitMethod = attributes.resubmitMethod;
            var name = '';
            var content = '';
            var avatar = get(item, 'operatorId.avatar');
            if (resubmitMethod === 'TO_REJECTOR') {
                if (attributes.resubmitOperatorIds && Array.isArray(attributes.resubmitOperatorIds)) {
                    name = (attributes === null || attributes === void 0 ? void 0 : attributes.isToInvoiceApplicationNode) ? i18n.get('开票申请')
                        : attributes.resubmitOperatorIds
                            .map(function (item) {
                            var itemCopy = __assign({}, item);
                            var name = getDisplayName(itemCopy);
                            var itemStaffDisplay = get(itemCopy, "" + flowStateMap.staffDisplayConfigField);
                            itemStaffDisplay &&
                                isString(itemStaffDisplay) &&
                                (itemCopy.name = name + (" (" + fnSubstr16(itemStaffDisplay) + ") "));
                            return name;
                        })
                            .join(',') || EBotName;
                }
            }
            else {
                name = getNameWithoutDelegate(item);
            }
            var toolTipTitle = '';
            if (needTipContent(name)) {
                toolTipTitle = (React.createElement(React.Fragment, null,
                    name,
                    " ",
                    i18n.get('提交送审')));
            }
            var staffName = getStaffName(item).staffName;
            content = (React.createElement(Tooltip, { placement: 'bottom', title: toolTipTitle },
                React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-gray'] },
                    renderAvatar(avatar),
                    React.createElement("div", { className: "text-container" },
                        React.createElement("span", { className: "text-ellipsis" }, staffName),
                        React.createElement("span", { className: "text-static approve-content-wrapper-content flex-s-0 ml-4" }, i18n.get('提交送审'))))));
            return { content: content };
        },
        render: function (_a) {
            var item = _a.item;
            var comment = item.attributes.comment;
            var _b = this.approveContent({ item: item }), content = _b.content, highlighterWords = _b.highlighterWords;
            return (React.createElement("div", { className: styles['content-wrapper'] },
                renderApproveContent({ content: content, highlighterWords: highlighterWords }),
                comment && React.createElement("div", { className: styles['content-msg'] + " translate-ignore-class" }, comment)));
        }
    },
    alter: {
        approveContent: function (_a) {
            var item = _a.item;
            var name = fnGetName(item);
            var avatar = get(item, 'operatorId.avatar');
            var _b = getStaffName(item), staffName = _b.staffName, byDelegateName = _b.byDelegateName;
            var content = (React.createElement(Tooltip, { placement: 'bottom', title: formatToolTipContent(name, i18n.get('发起变更申请')) },
                React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-info-content'] },
                    renderAvatar(avatar),
                    React.createElement("div", { className: "text-container" },
                        React.createElement(StaffNameComponent, { staffName: staffName, byDelegateName: byDelegateName, actionClassName: 'approve-content-wrapper-content-info' }),
                        React.createElement("span", { className: "text-static approve-content-wrapper-content-info flex-s-0 ml-4" }, i18n.get('发起变更申请'))))));
            return { content: content };
        },
        render: function (_a) {
            var item = _a.item, userInfo = _a.userInfo, config = _a.config;
            var attachments = item.attachments, _b = item.attributes, comment = _b.comment, autographImageId = _b.autographImageId;
            var hasAttachments = attachments && attachments.length > 0;
            var _c = this.approveContent({ item: item }), content = _c.content, highlighterWords = _c.highlighterWords;
            var atDom = addAtHighlighter(item, userInfo).atDom;
            return (React.createElement("div", { className: styles['content-wrapper'] },
                renderApproveContent({ content: content, highlighterWords: highlighterWords }, atDom),
                comment && React.createElement("div", { className: styles['content-msg'] + " translate-ignore-class" }, renderComment(item)),
                React.createElement("div", { className: "dis-f" },
                    hasAttachments && renderAttachments(attachments),
                    !!(autographImageId === null || autographImageId === void 0 ? void 0 : autographImageId.url) && React.createElement(AutographImage, { autographImageId: autographImageId }),
                    React.createElement(ConditionApporveTipView, { node: config === null || config === void 0 ? void 0 : config.node }))));
        }
    },
    agree: {
        approveContent: function (_a) {
            var _b;
            var item = _a.item;
            var name = fnGetName(item);
            var _c = getStaffName(item), staffName = _c.staffName, byDelegateName = _c.byDelegateName;
            var isEbotNode = get(item, 'attributes.isEbotNode');
            var isInvoiceApplicationNode = get(item, 'attributes.isInvoiceApplicationNode');
            var isRecalNode = get(item, 'attributes.isRecalNode');
            var aiAgentNode = isAIAgentNode(item);
            var result = get(item, 'attributes.extras.result');
            var showGray = aiAgentNode && !!result;
            var avatar = get(item, 'operatorId.avatar');
            var msg = result || i18n.get('审批同意');
            if (isEbotNode || isInvoiceApplicationNode || isRecalNode) {
                avatar = 'EBotIconNode';
                msg = i18n.get('执行完成');
                staffName = EBotName;
            }
            var isAutoNode = isEbotNode || isInvoiceApplicationNode || isRecalNode;
            var actionClassName = isAutoNode
                ? 'approve-content-wrapper-content-cyan'
                : showGray
                    ? 'approve-content-wrapper-content'
                    : 'approve-content-wrapper-content-green';
            var content = (React.createElement(Tooltip, { placement: 'bottom', title: formatToolTipContent(name, msg) },
                React.createElement("div", { className: classNames(styles['flow-log-action-wrapper'], (_b = {},
                        _b[styles['flow-log-action-wrapper-cyan']] = isAutoNode,
                        _b[styles['flow-log-action-wrapper-green']] = !showGray,
                        _b[styles['flow-log-action-wrapper-gray']] = showGray,
                        _b)) },
                    renderAvatar(avatar, styles['usr-icon-cyan-500']),
                    React.createElement("div", { className: "text-container" },
                        React.createElement(StaffNameComponent, { staffName: staffName, byDelegateName: byDelegateName, actionClassName: actionClassName }),
                        React.createElement("span", { className: classNames('text-static', 'ml-4', actionClassName) }, msg)))));
            return { content: content };
        },
        render: function (_a) {
            var _b;
            var item = _a.item, userInfo = _a.userInfo, config = _a.config;
            var attachments = item.attachments, _c = item.attributes, comment = _c.comment, autographImageId = _c.autographImageId;
            var hasAttachments = attachments && attachments.length > 0;
            var _d = this.approveContent({ item: item }), content = _d.content, highlighterWords = _d.highlighterWords;
            var atDom = addAtHighlighter(item, userInfo).atDom;
            var tips = get(item, 'attributes.extras.tips');
            return (React.createElement("div", { className: styles['content-wrapper'] },
                renderApproveContent({ content: content, highlighterWords: highlighterWords }, atDom),
                comment && (React.createElement("div", { className: classNames(styles['content-msg'], 'translate-ignore-class', (_b = {},
                        _b[styles['has-content-msg-tips']] = !!tips,
                        _b)) },
                    !!tips && React.createElement("div", { className: styles['content-msg-tips'] }, tips),
                    renderComment(item))),
                React.createElement("div", { className: "dis-f" },
                    hasAttachments && renderAttachments(attachments),
                    !!(autographImageId === null || autographImageId === void 0 ? void 0 : autographImageId.url) && React.createElement(AutographImage, { autographImageId: autographImageId }),
                    React.createElement(ConditionApporveTipView, { node: config === null || config === void 0 ? void 0 : config.node }))));
        }
    },
    autoAgree: {
        approveContent: function (_a) {
            var item = _a.item;
            var autoAgreeType = item.attributes.autoAgreeType;
            var name = fnGetName(item);
            var avatar = get(item, 'operatorId.avatar');
            var resion = agreeType()[autoAgreeType] || i18n.get('审批流程配置');
            var agreeReasion = autoAgreeType === 'NO_AUTO_AGREE' ? '' : resion;
            var _b = getStaffName(item), staffName = _b.staffName, byDelegateName = _b.byDelegateName;
            var content = (React.createElement("div", { className: "dis-f fd-c flex-1" },
                React.createElement(Tooltip, { placement: 'bottom', title: formatToolTipContent(name, i18n.get('自动同意')) },
                    React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-gray'] },
                        renderAvatar(avatar),
                        React.createElement("div", { className: "text-container" },
                            React.createElement(StaffNameComponent, { staffName: staffName, byDelegateName: byDelegateName, actionClassName: 'approve-content-wrapper-content' }),
                            React.createElement("span", { className: "text-static approve-content-wrapper-content flex-s-0 ml-4" }, i18n.get('自动同意'))))),
                (agreeReasion === null || agreeReasion === void 0 ? void 0 : agreeReasion.length) ? (React.createElement("div", { className: "mt-8 flex-1" },
                    React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-radius-4'] + " " + styles['flow-log-action-wrapper-gray'] },
                        React.createElement("div", { className: "approve-content-wrapper-content-caption" }, agreeReasion)))) : null));
            return { content: content };
        },
        render: function (_a) {
            var item = _a.item, config = _a.config;
            var attachments = item.attachments, _b = item.attributes, comment = _b.comment, autographImageId = _b.autographImageId;
            var avatar = get(item, 'operatorId.avatar');
            var hasAttachments = attachments && attachments.length;
            var _c = this.approveContent({ item: item }), content = _c.content, highlighterWords = _c.highlighterWords;
            return (React.createElement("div", { className: styles['content-wrapper'] },
                renderApproveContent({ content: content, highlighterWords: highlighterWords }),
                comment && React.createElement("div", { className: styles['content-msg'] + " translate-ignore-class" }, comment),
                React.createElement("div", { className: "dis-f" },
                    !!hasAttachments && renderAttachments(attachments),
                    !!(autographImageId === null || autographImageId === void 0 ? void 0 : autographImageId.url) && React.createElement(AutographImage, { autographImageId: autographImageId }),
                    React.createElement(ConditionApporveTipView, { node: config === null || config === void 0 ? void 0 : config.node }))));
        }
    },
    reject: {
        approveContent: function (_a) {
            var item = _a.item, commentInfo = _a.commentInfo, commentElement = _a.commentElement;
            var attributes = item.attributes;
            var resubmitMethod = attributes.resubmitMethod, nodeName = attributes.nodeName, isEbotNode = attributes.isEbotNode;
            var name = fnGetName(item);
            var avatar = get(item, 'operatorId.avatar');
            var isCostControlCheck = get(item, 'attributes.isCostControlCheck');
            var content = '';
            var _b = getStaffName(item), staffName = _b.staffName, byDelegateName = _b.byDelegateName;
            var actionMsg = i18n.get('驳回至');
            if (byDelegateName) {
                actionMsg = i18n.get('驳回');
            }
            if (isCostControlCheck) {
                var toolTipTitle = '';
                var msg = i18n.get('提交人');
                if (needTipContent(name)) {
                    toolTipTitle = (React.createElement(React.Fragment, null,
                        name,
                        " ",
                        i18n.get('驳回至'),
                        " ",
                        msg));
                }
                content = (React.createElement("div", { className: "dis-f fd-c flex-1" },
                    React.createElement(Tooltip, { placement: 'bottom', title: toolTipTitle },
                        React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-red'] },
                            renderAvatar(avatar, styles['usr-icon-danger-500']),
                            React.createElement("div", { className: "text-container" },
                                React.createElement(StaffNameComponent, { staffName: staffName, byDelegateName: byDelegateName, actionClassName: 'approve-content-wrapper-content-reject' }),
                                React.createElement("span", { className: "text-static approve-content-wrapper-content-reject ml-4" }, actionMsg),
                                byDelegateName ? null : (React.createElement("span", { className: "text-ellipsis approve-content-wrapper-name ml-4" }, msg))))),
                    (enableCommentRejectorOptimization() && resubmitMethod === 'TO_REJECTOR') ? (React.createElement("div", { className: styles['flow-log-action-wrapper-gray-text'] + " " + styles['content-msg'] + " translate-ignore-class" }, commentElement)) : null));
            }
            else if (resubmitMethod === 'TO_REJECTOR') {
                var toolTipTitle = '';
                var msg = nodeName || i18n.get('提交人');
                if (needTipContent(name)) {
                    toolTipTitle = (React.createElement(React.Fragment, null,
                        name,
                        " ",
                        i18n.get('驳回至'),
                        " ",
                        msg));
                }
                content = (React.createElement("div", { className: "dis-f fd-c flex-1" },
                    React.createElement(Tooltip, { placement: 'bottom', title: toolTipTitle },
                        React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-red'] },
                            renderAvatar(avatar, styles['usr-icon-danger-500']),
                            React.createElement("div", { className: "text-container" },
                                React.createElement(StaffNameComponent, { staffName: staffName, byDelegateName: byDelegateName, actionClassName: 'approve-content-wrapper-content-reject' }),
                                React.createElement("span", { className: "text-static approve-content-wrapper-content-reject ml-4" }, actionMsg),
                                byDelegateName ? null : (React.createElement("span", { className: "text-ellipsis approve-content-wrapper-name ml-4" }, msg))))),
                    React.createElement("div", { className: "mt-8 flex-1" },
                        React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-radius-4'] + " " + styles['flow-log-action-wrapper-gray'] + " " + styles['display-block'] },
                            React.createElement("div", { className: styles['content-msg-placeholder'] }, window.isInWeComISV ? (React.createElement(React.Fragment, null,
                                "\u91CD\u65B0\u63D0\u4EA4\u540E\u7531",
                                name,
                                "\u7EE7\u7EED\u5BA1\u6279")) : (i18n.get('重新提交后由{__k0}继续审批', { __k0: name }))),
                            React.createElement(Divider, { dashed: true, className: styles['reject-divider'] }),
                            React.createElement("div", { className: styles['flow-log-action-wrapper-gray-text'] }, commentElement)))));
            }
            else if (nodeName) {
                var toolTipTitle = '';
                if (needTipContent(name) || needTipContent(nodeName)) {
                    toolTipTitle = (React.createElement(React.Fragment, null,
                        name,
                        " ",
                        i18n.get('驳回至'),
                        " ",
                        nodeName));
                }
                content = (React.createElement(Tooltip, { placement: 'bottom', title: toolTipTitle },
                    React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-red'] },
                        renderAvatar(avatar, styles['usr-icon-danger-500']),
                        React.createElement("div", { className: "text-container" },
                            React.createElement(StaffNameComponent, { staffName: staffName, byDelegateName: byDelegateName, actionClassName: 'approve-content-wrapper-content-reject' }),
                            React.createElement("span", { className: "text-static approve-content-wrapper-content-reject ml-4" }, actionMsg),
                            byDelegateName ? null : React.createElement("span", { className: "text-ellipsis ml-4" }, nodeName)))));
            }
            else {
                content = (React.createElement(Tooltip, { placement: 'bottom', title: formatToolTipContent(name, i18n.get('驳回了单据')) },
                    React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-red'] },
                        renderAvatar(avatar, styles['usr-icon-danger-500']),
                        React.createElement("div", { className: "text-container" },
                            React.createElement(StaffNameComponent, { staffName: staffName, byDelegateName: byDelegateName, actionClassName: 'approve-content-wrapper-content-reject' }),
                            React.createElement("span", { className: "text-static approve-content-wrapper-content-reject ml-4" }, i18n.get('驳回了单据'))))));
            }
            return { content: content };
        },
        render: function (_a) {
            var _b;
            var item = _a.item, userInfo = _a.userInfo, config = _a.config;
            var attachments = item.attachments, _c = item.attributes, comment = _c.comment, autographImageId = _c.autographImageId, resubmitMethod = _c.resubmitMethod;
            var hasAttachments = attachments && attachments.length;
            var _d = addAtHighlighter(item, userInfo), atDom = _d.atDom, highlighterKey = _d.highlighterWords, commentContent = _d.content;
            var element = comment ? (React.createElement(Highlighter, { highlightClassName: styles['highlight'], searchWords: highlighterKey, textToHighlight: commentContent })) : (comment);
            var commentElement = comment && renderCommentWithMarkdown(commentContent, element);
            var _e = this.approveContent({ item: item, config: config, commentElement: commentElement }), content = _e.content, highlighterWords = _e.highlighterWords;
            var tips = get(item, 'attributes.extras.tips');
            return (React.createElement("div", { className: styles['content-wrapper'] },
                renderApproveContent({ content: content, highlighterWords: highlighterWords }, atDom),
                comment &&
                    (!!tips ? (React.createElement("div", { className: classNames(styles['content-msg'], 'translate-ignore-class', (_b = {},
                            _b[styles['has-content-msg-tips']] = !!tips,
                            _b)) },
                        React.createElement("div", { className: styles['content-msg-tips'] }, tips),
                        renderCommentWithMarkdown(commentContent, element))) : ((resubmitMethod !== 'TO_REJECTOR') && React.createElement("div", { className: styles['content-msg'] + " translate-ignore-class" }, commentElement))),
                React.createElement("div", { className: "dis-f" },
                    !!hasAttachments && renderAttachments(attachments),
                    !!(autographImageId === null || autographImageId === void 0 ? void 0 : autographImageId.url) && React.createElement(AutographImage, { autographImageId: autographImageId }),
                    React.createElement(ConditionApporveTipView, { node: config === null || config === void 0 ? void 0 : config.node }))));
        }
    },
    nullify: {
        approveContent: function (_a) {
            var item = _a.item;
            var name = fnGetName(item);
            var avatar = get(item, 'operatorId.avatar');
            var _b = getStaffName(item), staffName = _b.staffName, byDelegateName = _b.byDelegateName;
            var content = (React.createElement(Tooltip, { placement: 'bottom', title: formatToolTipContent(name, i18n.get('作废了单据')) },
                React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-red'] },
                    renderAvatar(avatar),
                    React.createElement("div", { className: "text-container" },
                        React.createElement(StaffNameComponent, { staffName: byDelegateName || staffName, actionClassName: 'approve-content-wrapper-content-reject' }),
                        React.createElement("span", { className: "text-static approve-content-wrapper-content-reject flex-s-0 ml-4" }, i18n.get('作废了单据'))))));
            return { content: content };
        },
        render: function (_a) {
            var item = _a.item;
            var content = this.approveContent({ item: item }).content;
            return renderApproveContent({ content: content });
        }
    },
    activate: {
        approveContent: function (_a) {
            var item = _a.item;
            var name = fnGetName(item);
            var avatar = get(item, 'operatorId.avatar');
            var staffName = getStaffName(item).staffName;
            var content = (React.createElement(Tooltip, { placement: 'bottom', title: formatToolTipContent(name, i18n.get('激活了单据')) },
                React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-green'] },
                    renderAvatar(avatar),
                    React.createElement("div", { className: "text-container" },
                        React.createElement(StaffNameComponent, { staffName: staffName, actionClassName: 'approve-content-wrapper-content-green' }),
                        React.createElement("span", { className: "text-static approve-content-wrapper-content-green ml-4" }, i18n.get('激活了单据'))))));
            return { content: content };
        },
        render: function (_a) {
            var item = _a.item;
            var content = this.approveContent({ item: item }).content;
            return renderApproveContent({ content: content });
        }
    },
    pay: {
        approveContent: function (_a) {
            var _b, _c, _d, _e, _f, _g, _h, _j, _k;
            var item = _a.item, billInfo = _a.billInfo;
            var name = getNameWithoutDelegate(item);
            var payMoney = billInfo.form.payMoney;
            var avatar = get(item, 'operatorId.avatar');
            var isPayZero = payMoney && Number(getMoney(payMoney)) === 0;
            var msg = '';
            if (isPayZero) {
                msg = i18n.get('（支付金额为0，无实际支付行为发生）');
            }
            var payMethod = '';
            var account = '';
            if (((_b = item === null || item === void 0 ? void 0 : item.attributes) === null || _b === void 0 ? void 0 : _b.comment) === '实际付款账户') {
                account = (_d = (_c = item === null || item === void 0 ? void 0 : item.attributes) === null || _c === void 0 ? void 0 : _c.accountCompany) === null || _d === void 0 ? void 0 : _d.name;
            }
            else if (((_e = item === null || item === void 0 ? void 0 : item.attributes) === null || _e === void 0 ? void 0 : _e.paymentChannel) === 'OFFLINE' && ((_f = item === null || item === void 0 ? void 0 : item.attributes) === null || _f === void 0 ? void 0 : _f.comment)) {
                payMethod = i18n.get('线下支付');
                account = (_g = item === null || item === void 0 ? void 0 : item.attributes) === null || _g === void 0 ? void 0 : _g.comment;
            }
            else if (((_h = item === null || item === void 0 ? void 0 : item.attributes) === null || _h === void 0 ? void 0 : _h.paymentChannel) === 'OFFLINE') {
                payMethod = i18n.get('线下支付');
                account = (_k = (_j = item === null || item === void 0 ? void 0 : item.attributes) === null || _j === void 0 ? void 0 : _j.accountCompany) === null || _k === void 0 ? void 0 : _k.name;
            }
            var staffName = getStaffName(item).staffName;
            var hasOtherMsg = !!payMethod || !!account || !!msg;
            var content = (React.createElement("div", { className: "dis-f fd-c flex-1" },
                React.createElement(Tooltip, { placement: 'bottom', title: formatToolTipContent(name, i18n.get('支付成功')) },
                    React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-green'] },
                        renderAvatar(avatar),
                        React.createElement("div", { className: "text-container" },
                            React.createElement("span", { className: "text-ellipsis" }, staffName),
                            React.createElement("span", { className: "text-static approve-content-wrapper-content-green flex-s-0 ml-4" }, i18n.get('支付成功'))))),
                hasOtherMsg ? (React.createElement("div", { className: "mt-8 flex-1" },
                    React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-radius-4'] + " " + styles['flow-log-action-wrapper-gray'] },
                        React.createElement("div", { className: "dis-f fd-c flex-1" },
                            payMethod ? (React.createElement("div", { className: "approve-content-wrapper-content-caption" }, i18n.get('方式') + "\uFF1A" + payMethod)) : null,
                            account ? (React.createElement("div", { className: "approve-content-wrapper-content-caption" }, i18n.get('账户') + "\uFF1A" + account)) : null,
                            msg ? React.createElement("div", { className: "approve-content-wrapper-content-caption" }, msg) : null)))) : null));
            return { content: content };
        },
        render: function (_a) {
            var item = _a.item, billInfo = _a.billInfo;
            var content = this.approveContent({ item: item, billInfo: billInfo }).content;
            return renderApproveContent({ content: content });
        }
    },
    paying: {
        approveContent: function (_a) {
            var _b, _c;
            var item = _a.item;
            var _d = item.attributes, accountCompany = _d.accountCompany, paymentChannel = _d.paymentChannel, dynamicChannelMap = item.dynamicChannelMap;
            var payName = accountCompany ? accountCompany === null || accountCompany === void 0 ? void 0 : accountCompany.name : i18n.get('无');
            var name = getNameWithoutDelegate(item);
            var payChannel = ((_b = dynamicChannelMap === null || dynamicChannelMap === void 0 ? void 0 : dynamicChannelMap[paymentChannel]) === null || _b === void 0 ? void 0 : _b.name) || i18n.get('无');
            var msg = i18n.get('发起支付');
            var payMethod = i18n.get(payChannel);
            var account = i18n.get(payName);
            if (item.attributes.hasOwnProperty('reviewResult')) {
                if ((_c = item.attributes) === null || _c === void 0 ? void 0 : _c.reviewResult) {
                    msg = i18n.get('同意支付');
                }
                else {
                    msg = i18n.get('驳回支付');
                }
            }
            var staffName = getStaffName(item).staffName;
            var avatar = get(item, 'operatorId.avatar');
            var content = (React.createElement("div", { className: "dis-f fd-c flex-1" },
                React.createElement(Tooltip, { placement: 'bottom', title: formatToolTipContent(name, msg) },
                    React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-gray'] },
                        renderAvatar(avatar),
                        React.createElement("div", { className: "text-container" },
                            React.createElement("span", { className: "text-ellipsis" }, staffName),
                            React.createElement("span", { className: "text-static approve-content-wrapper-content ml-4" }, msg)))),
                React.createElement("div", { className: "mt-8 flex-1" },
                    React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-radius-4'] + " " + styles['flow-log-action-wrapper-gray'] },
                        React.createElement("div", { className: "dis-f fd-c flex-1" },
                            payMethod ? (React.createElement("div", { className: "approve-content-wrapper-content-caption" }, i18n.get('方式') + "\uFF1A" + payMethod)) : null,
                            account ? (React.createElement(Ellipsis, { className: 'approve-content-wrapper-content-caption', direction: "end", rows: 2, content: i18n.get('账户') + "\uFF1A" + account, expandText: i18n.get('展开'), collapseText: i18n.get('收起') })) :
                                null,
                            React.createElement(PayeeInfoPopover, { paymentInfos: item.attributes.paymentInfos },
                                React.createElement("div", { className: "approve-content-wrapper-content-payInfo" }, i18n.get('查看收款信息'))))))));
            return { content: content };
        },
        render: function (_a) {
            var _b, _c, _d;
            var item = _a.item, config = _a.config;
            var _e = item.attributes, comment = _e.comment, autographImageId = _e.autographImageId;
            var content = this.approveContent({ item: item }).content;
            return (React.createElement("div", { className: styles['content-wrapper'] },
                renderApproveContent({ content: content }),
                comment && (React.createElement("div", { className: styles['content-msg'] + " translate-ignore-class" },
                    ((_c = (_b = item.attributes) === null || _b === void 0 ? void 0 : _b.hasOwnProperty) === null || _c === void 0 ? void 0 : _c.call(_b, 'reviewResult')) && !((_d = item.attributes) === null || _d === void 0 ? void 0 : _d.reviewResult)
                        ? i18n.get('原因') + "\uFF1A"
                        : '',
                    comment)),
                !!(autographImageId === null || autographImageId === void 0 ? void 0 : autographImageId.url) && React.createElement(AutographImage, { autographImageId: autographImageId }),
                React.createElement(ConditionApporveTipView, { node: config === null || config === void 0 ? void 0 : config.node })));
        }
    },
    repaying: {
        approveContent: function (_a) {
            var item = _a.item;
            var _b = item.attributes, accountCompany = _b.accountCompany, paymentChannel = _b.paymentChannel, _c = _b.repayReason, repayReason = _c === void 0 ? '' : _c, dynamicChannelMap = item.dynamicChannelMap;
            var payName = accountCompany ? accountCompany.name : i18n.get('无');
            var name = getNameWithoutDelegate(item);
            var payChannel = dynamicChannelMap[paymentChannel].name || i18n.get('无');
            var reason = repayReason || emptyStr;
            var msg = i18n.get('发起重新支付');
            var payMethod = i18n.get(payChannel);
            var account = i18n.get(payName);
            var avatar = get(item, 'operatorId.avatar');
            var staffName = getStaffName(item).staffName;
            var content = (React.createElement("div", { className: "dis-f fd-c flex-1" },
                React.createElement(Tooltip, { placement: 'bottom', title: formatToolTipContent(name, msg) },
                    React.createElement("div", { className: "text-container" },
                        React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-gray'] },
                            renderAvatar(avatar),
                            React.createElement("span", { className: "text-ellipsis" }, staffName),
                            React.createElement("span", { className: "text-static approve-content-wrapper-content ml-4" }, msg)))),
                React.createElement("div", { className: "mt-8 flex-1" },
                    React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-radius-4'] + " " + styles['flow-log-action-wrapper-gray'] },
                        React.createElement("div", { className: "dis-f fd-c flex-1" },
                            payMethod ? (React.createElement("div", { className: "approve-content-wrapper-content-caption" }, i18n.get('方式') + "\uFF1A" + payMethod)) : null,
                            account ? (React.createElement("div", { className: "approve-content-wrapper-content-caption" }, i18n.get('账户') + "\uFF1A" + account)) : null,
                            reason ? (React.createElement("div", { className: "approve-content-wrapper-content-caption" }, i18n.get('账户') + "\uFF1A" + account)) : null,
                            React.createElement(PayeeInfoPopover, { paymentInfos: item.attributes.paymentInfos },
                                React.createElement("div", { className: "approve-content-wrapper-content-payInfo" }, i18n.get('查看收款信息'))))))));
            return { content: content };
        },
        render: function (_a) {
            var item = _a.item, config = _a.config;
            var _b = item.attributes, comment = _b.comment, autographImageId = _b.autographImageId;
            var _c = this.approveContent({ item: item }), content = _c.content, highlighterWords = _c.highlighterWords;
            return (React.createElement("div", { className: styles['content-wrapper'] },
                renderApproveContent({ content: content, highlighterWords: highlighterWords }),
                comment && React.createElement("div", { className: styles['content-msg'] + " translate-ignore-class" }, comment),
                !!(autographImageId === null || autographImageId === void 0 ? void 0 : autographImageId.url) && React.createElement(AutographImage, { autographImageId: autographImageId }),
                React.createElement(ConditionApporveTipView, { node: config === null || config === void 0 ? void 0 : config.node })));
        }
    },
    'pay.by.offline': {
        approveContent: function (_a) {
            var item = _a.item;
            var paymentInfos = item.attributes.paymentInfos;
            var _b = (paymentInfos && paymentInfos[0]) || {}, amount = _b.amount, _c = _b.payeeId, payeeId = _c === void 0 ? {} : _c, _d = _b.feeTypeId, feeTypeId = _d === void 0 ? {} : _d;
            var _amount = (amount === null || amount === void 0 ? void 0 : amount.standard) ? amount === null || amount === void 0 ? void 0 : amount.standard : amount;
            var payName = payeeId.name || i18n.get('无');
            var name = getNameWithoutDelegate(item);
            var payChannel = i18n.get('线下支付');
            var feeTypeName = i18n.get((feeTypeId && feeTypeId.name) || i18n.get('无'));
            var payMoney = new Big(_amount || 0).toFixed(2);
            var msg = i18n.get('修改支付方式');
            var payMethod = i18n.get(payChannel);
            var avatar = get(item, 'operatorId.avatar');
            var staffName = getStaffName(item).staffName;
            var content = (React.createElement("div", { className: "dis-f fd-c flex-1" },
                React.createElement(Tooltip, { placement: 'bottom', title: formatToolTipContent(name, msg) },
                    React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-gray'] },
                        renderAvatar(avatar),
                        React.createElement("div", { className: "text-container" },
                            React.createElement("span", { className: "text-ellipsis" }, staffName),
                            React.createElement("span", { className: "text-static approve-content-wrapper-content ml-4" }, msg)))),
                React.createElement("div", { className: "mt-8 flex-1" },
                    React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-radius-4'] + " " + styles['flow-log-action-wrapper-gray'] },
                        React.createElement("div", { className: "dis-f fd-c flex-1" },
                            React.createElement("div", { className: "approve-content-wrapper-content-caption" }, i18n.get('方式') + "\uFF1A" + payMethod),
                            React.createElement("div", { className: "approve-content-wrapper-content-caption" }, i18n.get('账户') + "\uFF1A" + payName),
                            React.createElement("div", { className: "approve-content-wrapper-content-caption" }, i18n.get('费用类型') + "\uFF1A" + feeTypeName),
                            React.createElement("div", { className: "approve-content-wrapper-content-caption" }, i18n.get('支付金额') + "\uFF1A" + payMoney))))));
            return { content: content };
        },
        render: function (_a) {
            var item = _a.item;
            var content = this.approveContent({ item: item }).content;
            return React.createElement("div", { className: styles['content-wrapper'] }, renderApproveContent({ content: content }));
        }
    },
    failure: {
        approveContent: function (_a) {
            var item = _a.item;
            var failureReason = item.attributes.failureReason;
            var name = getNameWithoutDelegate(item);
            var avatar = get(item, 'operatorId.avatar');
            var staffName = getStaffName(item).staffName;
            var content = (React.createElement("div", { className: "dis-f fd-c flex-1" },
                React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-red'] },
                    renderAvatar(avatar, styles['usr-icon-danger-500']),
                    React.createElement("div", { className: "text-container" },
                        React.createElement(Tooltip, { placement: 'bottom', title: name },
                            React.createElement("span", { className: "text-ellipsis" }, staffName)),
                        React.createElement("span", { className: "text-static approve-content-wrapper-content-reject ml-4" }, i18n.get('支付失败')))),
                React.createElement("div", { className: "mt-8 flex-1" },
                    React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-radius-4'] + " " + styles['flow-log-action-wrapper-gray'] },
                        React.createElement("div", { className: "dis-f fd-c flex-1" },
                            React.createElement("div", { className: "approve-content-wrapper-content-caption" }, failureReason),
                            React.createElement(PayeeInfoPopover, { paymentInfos: item.attributes.paymentInfos, showFailureReason: true },
                                React.createElement("div", { className: "approve-content-wrapper-content-payInfo" }, i18n.get('查看收款信息'))))))));
            return { content: content };
        },
        render: function (_a) {
            var item = _a.item, config = _a.config;
            var _b = item.attributes, comment = _b.comment, autographImageId = _b.autographImageId;
            var content = this.approveContent({ item: item }).content;
            return (React.createElement("div", { className: styles['content-wrapper'] },
                renderApproveContent({ content: content }),
                comment && React.createElement("div", { className: styles['content-msg'] + " translate-ignore-class" }, comment),
                !!(autographImageId === null || autographImageId === void 0 ? void 0 : autographImageId.url) && React.createElement(AutographImage, { autographImageId: autographImageId }),
                React.createElement(ConditionApporveTipView, { node: config === null || config === void 0 ? void 0 : config.node })));
        }
    },
    'select.approver': {
        getNewApproverNames: function (newApproverIds, dataSource) {
            var _a;
            if (newApproverIds === void 0) { newApproverIds = []; }
            var planNode = ((_a = dataSource === null || dataSource === void 0 ? void 0 : dataSource.plan) === null || _a === void 0 ? void 0 : _a.nodes) || [];
            var lastIndex = newApproverIds.length - 1;
            return newApproverIds.reduce(function (acc, id, idx) {
                var node = planNode.find(function (item) { var _a; return ((_a = item.approverId) === null || _a === void 0 ? void 0 : _a.id) === id; });
                var nextName = node ? getStaffShowByConfig(node.approverId) : '';
                if (idx === lastIndex) {
                    acc.push(nextName);
                }
                else {
                    acc.push(nextName, i18n.get('，'));
                }
                return acc;
            }, []);
        },
        approveContent: function (_a) {
            var item = _a.item, billInfo = _a.billInfo;
            var _b = item.attributes, nodeLabel = _b.label, oldApproverId = _b.oldApproverId, newApproverId = _b.newApproverId, newApproverNames = _b.newApproverNames, newApproverIds = _b.newApproverIds;
            var avatar = get(item, 'operatorId.avatar');
            var preName = oldApproverId ? getStaffShowByConfig(oldApproverId) : '';
            var oldOperatorAvatar = get(oldApproverId, 'avatar');
            var nextOperatorAvatar = get(newApproverId, 'avatar');
            var nextName = newApproverIds
                ? this.getNewApproverNames(newApproverIds, billInfo)
                : (newApproverNames === null || newApproverNames === void 0 ? void 0 : newApproverNames.join(i18n.get('，'))) || '';
            var name = fnGetName(item);
            var nodeName = isPayNode(item.attributes)
                ? nodeLabel
                    ? nodeLabel
                    : item.attributes.name
                : item.attributes.name;
            var preStaffDisplay = oldApproverId === null || oldApproverId === void 0 ? void 0 : oldApproverId[flowStateMap.staffDisplayConfigField];
            preStaffDisplay && isString(preStaffDisplay) && (preName = preName + " (" + fnSubstr16(preStaffDisplay) + ") ");
            var actionName = i18n.get('指派审批人');
            var _c = getStaffName(item), staffName = _c.staffName, byDelegateName = _c.byDelegateName;
            var content = (React.createElement(UpdateApproverPopover, { title: actionName, name: name, nextName: nextName, nextOperatorAvatar: nextOperatorAvatar, oldOperatorAvatar: oldOperatorAvatar, nodeName: nodeName, preName: preName },
                React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-info'] + " cur-p" },
                    React.createElement("div", { className: "text-container" },
                        renderAvatar(avatar),
                        React.createElement(StaffNameComponent, { staffName: staffName, byDelegateName: byDelegateName, actionClassName: 'approve-content-wrapper-content-info' }),
                        React.createElement("span", { className: "text-static approve-content-wrapper-content-info ml-4" }, actionName)))));
            return { content: content };
        },
        render: function (obj) {
            var content = this.approveContent(obj).content;
            return renderApproveContent({ content: content });
        }
    },
    skipped: {
        approveContent: function (_a) {
            var _b, _c, _d;
            var item = _a.item;
            var skippedType = item.attributes.skippedType;
            var name = (_b = item === null || item === void 0 ? void 0 : item.attributes) === null || _b === void 0 ? void 0 : _b.name;
            var skipDetail = skippedTypeMap()[skippedType];
            var avatar = get(item, 'operatorId.avatar');
            var _e = getStaffName(item), staffName = _e.staffName, byDelegateName = _e.byDelegateName;
            var avatarIconClass = '';
            if (showEBotSkippedTypes.includes(skippedType)) {
                avatar = 'EBotIconNode';
                staffName = EBotName;
                name = staffName;
                avatarIconClass = styles['usr-icon-neu-400'];
            }
            if (skippedType === 'AI_APPROVAL') {
                var staffs = getSkippedNodeStaff(item) || [];
                avatar = (_c = staffs[0]) === null || _c === void 0 ? void 0 : _c.avatar;
                staffName = (_d = staffs[0]) === null || _d === void 0 ? void 0 : _d.name;
                name = staffName;
                if (staffs.length > 1) {
                    avatar = staffs.map(function (item) { return item.avatar; });
                    staffName = staffs.length + "\u540D\u6210\u5458";
                    name = staffName;
                }
            }
            var content = (React.createElement("div", { className: "dis-f fd-c flex-1" },
                React.createElement(Tooltip, { placement: 'bottom', title: formatToolTipContent(name, i18n.get('自动跳过')) },
                    React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-gray'] },
                        renderAvatar(avatar, avatarIconClass),
                        React.createElement("div", { className: "text-container" },
                            React.createElement(StaffNameComponent, { staffName: staffName, byDelegateName: byDelegateName, actionClassName: 'approve-content-wrapper-content' }),
                            React.createElement("span", { className: "text-static approve-content-wrapper-content ml-4" }, i18n.get('自动跳过'))))),
                React.createElement("div", { className: "mt-8 flex-1" },
                    React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-radius-4'] + " " + styles['flow-log-action-wrapper-gray'] },
                        React.createElement("div", { className: "approve-content-wrapper-content-caption" }, skipDetail ? i18n.get(skipDetail) : skipDetail)))));
            return { content: content };
        },
        render: function (_a) {
            var item = _a.item, config = _a.config;
            var _b = item.attributes, comment = _b.comment, autographImageId = _b.autographImageId;
            var content = this.approveContent({ item: item }).content;
            return (React.createElement("div", { className: styles['content-wrapper'] },
                renderApproveContent({ content: content }),
                comment && React.createElement("div", { className: styles['content-msg'] + " translate-ignore-class" }, comment),
                !!(autographImageId === null || autographImageId === void 0 ? void 0 : autographImageId.url) && React.createElement(AutographImage, { autographImageId: autographImageId }),
                React.createElement(ConditionApporveTipView, { node: config === null || config === void 0 ? void 0 : config.node })));
        }
    },
    modify: {
        approveContent: function (_a) {
            var item = _a.item, text = _a.text, onViewVersionClick = _a.onViewVersionClick;
            var defaultText = '';
            var contentInfoClassName = 'approve-content-wrapper-content-info';
            var showVersion = true;
            var logWrapperClassName = styles['flow-log-action-wrapper-info-content'];
            var _b = getStaffName(item), staffName = _b.staffName, byDelegateName = _b.byDelegateName;
            if (item.operatorState) {
                var _c = fnGetOperatorStateStr(item.operatorState), content_1 = _c.content, className = _c.className, showVersionButton = _c.showVersion, wrapperClassName = _c.wrapperClassName;
                contentInfoClassName = className;
                defaultText = content_1;
                showVersion = showVersionButton;
                logWrapperClassName = wrapperClassName;
            }
            var name = fnGetName(item);
            var avatar = get(item, 'operatorId.avatar');
            var flowVersionedId = item.flowVersionedId;
            var subDom = showVersion && flowVersionedId && renderVersion(item, onViewVersionClick);
            var toolTipTitle = '';
            if (needTipContent(name)) {
                toolTipTitle = (React.createElement(React.Fragment, null,
                    name,
                    " ",
                    text));
            }
            var content = (React.createElement("div", { className: "dis-f jc-sb flex-1 ai-c" },
                React.createElement(Tooltip, { placement: 'bottom', title: toolTipTitle },
                    React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + logWrapperClassName },
                        renderAvatar(avatar, styles['usr-icon-info-500']),
                        React.createElement("div", { className: "text-container text-container-middle-130" },
                            React.createElement(StaffNameComponent, { staffName: byDelegateName || staffName, actionClassName: contentInfoClassName }),
                            React.createElement("span", { className: "text-static " + contentInfoClassName + " ml-4" }, text || defaultText)))),
                subDom));
            return { content: content };
        },
        render: function (_a) {
            var item = _a.item, onViewVersionClick = _a.onViewVersionClick;
            var text = i18n.get('修改了单据');
            if (item.operatorState) {
                var content_2 = fnGetOperatorStateStr(item.operatorState).content;
                text = content_2;
            }
            if (item.operatorId === 'ebot') {
                item.operatorId = { name: EBotName, avatar: 'EBotIconNode' };
            }
            var editeReason = item.editeReason;
            var _b = this.approveContent({ item: item, text: text, onViewVersionClick: onViewVersionClick }), content = _b.content, highlighterWords = _b.highlighterWords;
            return (React.createElement("div", { className: styles['content-wrapper'] },
                renderApproveContent({ content: content, highlighterWords: highlighterWords }),
                editeReason && React.createElement("div", { className: styles['content-msg'] + " translate-ignore-class" }, editeReason)));
        }
    },
    comment: {
        approveContent: function (_a) {
            var _this = this;
            var item = _a.item, config = _a.config, billInfo = _a.billInfo, bus = _a.bus;
            var logIndex = config.logIndex, privilegeId = config.privilegeId;
            var name = fnGetName(item);
            var avatar = get(item, 'operatorId.avatar');
            var msg = i18n.get('发表评论');
            var staffName = getStaffName(item).staffName;
            var content = (React.createElement(Tooltip, { placement: 'bottom', title: formatToolTipContent(name, msg) },
                React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-gray'] },
                    renderAvatar(avatar),
                    React.createElement("div", { className: "text-container" },
                        React.createElement("span", { className: "text-ellipsis" }, staffName),
                        React.createElement("span", { className: "text-static approve-content-wrapper-content flex-s-0 ml-4" }, msg)))));
            var fnDeleteComment = function () { return __awaiter(_this, void 0, void 0, function () {
                var res;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, deleteComment({
                                flowId: billInfo.id,
                                logIndex: item.index,
                                privilegeId: privilegeId,
                                id: item.id,
                                time: item.time
                            })];
                        case 1:
                            res = _a.sent();
                            if (res === null || res === void 0 ? void 0 : res.value) {
                                message.success(i18n.get('评论删除成功'));
                                bus.invoke('bills:update:flow');
                            }
                            else {
                                message.error(i18n.get('评论删除失败'));
                            }
                            return [2];
                    }
                });
            }); };
            var deleteCommentIcon = (React.createElement(Popconfirm, { title: i18n.get('确认删除此评论？'), content: i18n.get('删除操作不可撤回'), placement: "bottomRight", onConfirm: fnDeleteComment, overlayStyle: { width: 258 }, align: { targetOffset: [-16, 10] } },
                React.createElement(Button, { category: "text", icon: React.createElement(OutlinedEditDeleteTrash, null), size: "mini" })));
            return { content: content, deleteCommentIcon: deleteCommentIcon };
        },
        render: function (_a) {
            var item = _a.item, config = _a.config, billInfo = _a.billInfo, bus = _a.bus;
            var attachments = item.attachments, _b = item.attributes, _c = _b.participants, participants = _c === void 0 ? [] : _c, comment = _b.comment, _d = _b.receiverIds, receiverIds = _d === void 0 ? [] : _d, autographImageId = _b.autographImageId, delOperatorId = _b.delOperatorId, delTime = _b.delTime;
            var canDeleteComment = config.canDeleteComment;
            var com = comment2MentionContent(comment, participants, flowStateMap.staffDisplayConfigField);
            var highlighterWords = participants.map(function (item) { return " @" + getStaffShowByConfig(item) + " "; });
            highlighterWords = parseReg(highlighterWords);
            var receivers = receiverIds.map(function (item) { return getStaffShowByConfig(item); }).join(i18n.get('、'));
            var hasAttachments = attachments && attachments.length > 0;
            var _e = this.approveContent({ item: item, config: config, billInfo: billInfo, bus: bus }), content = _e.content, deleteCommentIcon = _e.deleteCommentIcon;
            var delOperator = delOperatorId && getStaffShowByConfig(delOperatorId);
            var delTimeFormat = delTime && moment(delTime).format('YYYY-MM-DD HH:mm');
            var element = comment ? (React.createElement(Highlighter, { highlightClassName: styles['highlight'], searchWords: highlighterWords, textToHighlight: com })) : (comment);
            return (React.createElement("div", { className: styles['content-wrapper'] },
                renderApproveContent({
                    content: content,
                    deleteCommentIcon: canDeleteComment && !delOperatorId && deleteCommentIcon
                }),
                React.createElement("div", { className: styles['content-msg'] + " translate-ignore-class fd-c" },
                    comment && renderCommentWithMarkdown(com, element),
                    !comment && delOperatorId && (React.createElement(Tooltip, { placement: "bottom", title: i18n.get('评论已被管理员{__k0}于{__k1}删除', { __k0: delOperator, __k1: delTimeFormat }) },
                        React.createElement("div", { className: styles['content-msg-placeholder'] }, i18n.get('评论已被管理员删除（{__k0}）', { __k0: delTimeFormat })))),
                    receivers.length > 0 && (React.createElement("div", { className: styles['dashed-separator'] }, i18n.get('mentioned', { name: receivers })))),
                !!(autographImageId === null || autographImageId === void 0 ? void 0 : autographImageId.url) && React.createElement(AutographImage, { autographImageId: autographImageId }),
                hasAttachments && renderAttachments(attachments)));
        }
    },
    carbonCopy: {
        approveContent: function (_a) {
            var item = _a.item;
            var carbonCopy = item.attributes.carbonCopy;
            if ((carbonCopy === null || carbonCopy === void 0 ? void 0 : carbonCopy.length) > 1) {
                var content_3 = (React.createElement(Popover, { placement: 'bottom', title: i18n.get('抄送单据给'), content: React.createElement("div", { className: styles['flow-log-carbonCopy-wrapper'] + " cur-p" }, carbonCopy.map(function (item) {
                        var avatar = get(item, 'avatar');
                        var name = fnGetName({ operatorId: item });
                        return (React.createElement("div", { key: item.id, className: 'flow-log-carbonCopy-row' },
                            renderAvatar(avatar),
                            " ",
                            React.createElement("span", { className: "ml-4" }, name)));
                    })) },
                    React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-gray'] },
                        React.createElement("div", { className: styles['user-icon'] + " " + styles['usr-icon-neu-500'] + " p-2" },
                            React.createElement(FilledGeneralPosition, { style: { marginBottom: 2 }, fontSize: 10, color: 'var(--eui-bg-body)' })),
                        React.createElement("div", { className: "text-container" },
                            React.createElement("span", { className: "text-static approve-content-wrapper-content mr-4" }, i18n.get('抄送单据给')),
                            React.createElement("span", { className: "text-ellipsis ml-4" }, i18n.get('{__k0}名成员', { __k0: carbonCopy.length }))))));
                return { content: content_3 };
            }
            var msg = '';
            var toolTipTitle = '';
            if ((carbonCopy === null || carbonCopy === void 0 ? void 0 : carbonCopy.length) === 1) {
                var staffName = getStaffName({ operatorId: carbonCopy[0] }).staffName;
                msg = staffName;
                toolTipTitle = (React.createElement(React.Fragment, null,
                    i18n.get('抄送单据给'),
                    " ",
                    fnGetName({ operatorId: carbonCopy[0] })));
            }
            else if (needTipContent(toolTipTitle)) {
                toolTipTitle = (React.createElement(React.Fragment, null,
                    i18n.get('抄送单据给'),
                    " ",
                    toolTipTitle));
            }
            var content = (React.createElement(Tooltip, { placement: 'bottom', title: toolTipTitle },
                React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-gray'] },
                    React.createElement("div", { className: styles['user-icon'] + " " + styles['usr-icon-neu-500'] },
                        React.createElement(FilledGeneralPosition, { fontSize: 10, color: 'var(--eui-bg-body)' })),
                    React.createElement("div", { className: "text-container" }, !(carbonCopy === null || carbonCopy === void 0 ? void 0 : carbonCopy.length) ? (React.createElement(React.Fragment, null,
                        React.createElement("span", { className: "text-ellipsis mr-4" }, i18n.get('匹配不到抄送人')),
                        React.createElement("span", { className: "text-static approve-content-wrapper-content" }, i18n.get('自动跳过')))) : (React.createElement(React.Fragment, null,
                        React.createElement("span", { className: "text-static approve-content-wrapper-content mr-4" }, i18n.get('抄送单据给')),
                        React.createElement("span", { className: "text-ellipsis" }, msg)))))));
            return { content: content };
        },
        render: function (_a) {
            var item = _a.item;
            var avatar = get(item, 'operatorId.avatar');
            var _b = this.approveContent({ item: item }), content = _b.content, highlighterWords = _b.highlighterWords;
            return (React.createElement("div", { className: styles['content-wrapper'] }, renderApproveContent({ content: content, highlighterWords: highlighterWords, avatar: avatar })));
        }
    },
    back: {
        approveContent: function (_a) {
            var item = _a.item;
            var name = fnGetName(item);
            var type = get(item, 'attributes.type');
            var avatar = get(item, 'operatorId.avatar');
            var nodeName = '';
            var backNodeMsg = i18n.get('撤回支付');
            var actionName = i18n.get('撤回支付');
            var className = styles['flow-log-action-wrapper-red'];
            var actionNameClassName = 'approve-content-wrapper-content-reject';
            if (type === 'rollback') {
                className = styles['flow-log-action-wrapper-gray'];
                actionNameClassName = 'approve-content-wrapper-content';
                actionName = i18n.get('回退至');
                nodeName = get(item, 'attributes.nodeName');
                backNodeMsg = nodeName ? "" + actionName + nodeName : nodeName;
            }
            var toolTipTitle = '';
            if (needTipContent(name) || needTipContent(nodeName)) {
                toolTipTitle = (React.createElement(React.Fragment, null,
                    name,
                    " ",
                    backNodeMsg));
            }
            var _b = getStaffName(item), staffName = _b.staffName, byDelegateName = _b.byDelegateName;
            var content = (React.createElement(Tooltip, { placement: 'bottom', title: toolTipTitle },
                React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + className },
                    renderAvatar(avatar),
                    React.createElement("div", { className: "text-container" },
                        React.createElement(StaffNameComponent, { staffName: staffName, byDelegateName: type === 'rollback' ? null : byDelegateName, actionClassName: actionNameClassName }),
                        React.createElement("span", { className: "text-static " + actionNameClassName + " ml-4" }, actionName),
                        nodeName ? React.createElement("span", { className: "text-ellipsis approve-content-wrapper-name ml-4" }, nodeName) : null))));
            return { content: content };
        },
        render: function (_a) {
            var item = _a.item;
            var attachments = item.attachments, _b = item.attributes, comment = _b.comment, autographImageId = _b.autographImageId;
            var hasAttachments = attachments && attachments.length > 0;
            var content = this.approveContent({ item: item }).content;
            return (React.createElement("div", { className: styles['content-wrapper'] },
                renderApproveContent({ content: content }),
                comment && React.createElement("div", { className: styles['content-msg'] + " translate-ignore-class" }, comment),
                React.createElement("div", { className: "dis-f" },
                    hasAttachments && renderAttachments(attachments),
                    !!(autographImageId === null || autographImageId === void 0 ? void 0 : autographImageId.url) && React.createElement(AutographImage, { autographImageId: autographImageId }))));
        }
    },
    send: renderExpress('send'),
    receive: renderExpress('receive'),
    receiveExcep: renderExpress('receiveExcep'),
    cancelReceiveExcep: renderExpress('cancelReceiveExcep'),
    compliance: {
        approveContent: function (_a) {
            var item = _a.item;
            var name = fnGetName(item);
            var avatar = get(item, 'operatorId.avatar');
            var _b = getStaffName(item), staffName = _b.staffName, byDelegateName = _b.byDelegateName;
            var content = (React.createElement(Tooltip, { placement: 'bottom', title: formatToolTipContent(name, i18n.get('完成了合规性确认')) },
                React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-gray'] },
                    renderAvatar(avatar),
                    React.createElement("div", { className: "text-container" },
                        React.createElement(StaffNameComponent, { staffName: staffName, byDelegateName: byDelegateName, actionClassName: 'approve-content-wrapper-content' }),
                        React.createElement("span", { className: "text-static approve-content-wrapper-content ml-4" }, i18n.get('完成了合规性确认'))))));
            return { content: content };
        },
        render: function (_a) {
            var item = _a.item, config = _a.config;
            var _b = item.attributes, comment = _b.comment, autographImageId = _b.autographImageId;
            var content = this.approveContent({ item: item }).content;
            return (React.createElement("div", { className: styles['content-wrapper'] },
                renderApproveContent({ content: content }),
                comment && React.createElement("div", { className: styles['content-msg'] + " translate-ignore-class" }, renderComment(item)),
                !!(autographImageId === null || autographImageId === void 0 ? void 0 : autographImageId.url) && React.createElement(AutographImage, { autographImageId: autographImageId }),
                React.createElement(ConditionApporveTipView, { node: config === null || config === void 0 ? void 0 : config.node })));
        }
    },
    'signing.failed': {
        approveContent: function (_a) {
            var item = _a.item;
            var name = fnGetName(item);
            var avatar = get(item, 'operatorId.avatar');
            var staffName = getStaffName(item).staffName;
            var content = (React.createElement(Tooltip, { placement: 'bottom', title: formatToolTipContent(name, i18n.get('签署失败')) },
                React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-red'] },
                    renderAvatar(avatar),
                    React.createElement("div", { className: "text-container" },
                        React.createElement("span", { className: "text-ellipsis" }, staffName),
                        React.createElement("span", { className: "text-static approve-content-wrapper-content-reject ml-4" }, i18n.get('签署失败'))))));
            return { content: content };
        },
        render: function (_a) {
            var item = _a.item, config = _a.config;
            var _b = item.attributes, comment = _b.comment, autographImageId = _b.autographImageId;
            var content = this.approveContent({ item: item }).content;
            return (React.createElement("div", { className: styles['content-wrapper'] },
                renderApproveContent({ content: content }),
                comment && React.createElement("div", { className: styles['content-msg'] + " translate-ignore-class" }, renderComment(item)),
                !!(autographImageId === null || autographImageId === void 0 ? void 0 : autographImageId.url) && React.createElement(AutographImage, { autographImageId: autographImageId }),
                React.createElement(ConditionApporveTipView, { node: config === null || config === void 0 ? void 0 : config.node })));
        }
    },
    'pay.partial.paying': {
        approveContent: function (_a) {
            var _b;
            var item = _a.item;
            var _c = item.attributes, accountCompany = _c.accountCompany, paymentChannel = _c.paymentChannel, dynamicChannelMap = item.dynamicChannelMap;
            var avatar = get(item, 'operatorId.avatar');
            var payName = accountCompany ? accountCompany === null || accountCompany === void 0 ? void 0 : accountCompany.name : i18n.get('无');
            var name = getNameWithoutDelegate(item);
            var payChannel = ((_b = dynamicChannelMap === null || dynamicChannelMap === void 0 ? void 0 : dynamicChannelMap[paymentChannel]) === null || _b === void 0 ? void 0 : _b.name) || i18n.get('无');
            var msg = i18n.get('发起部分支付');
            var payMethod = i18n.get(payChannel);
            var account = i18n.get(payName);
            var staffName = getStaffName(item).staffName;
            var content = (React.createElement("div", { className: "dis-f fd-c flex-1" },
                React.createElement(Tooltip, { placement: 'bottom', title: formatToolTipContent(name, msg) },
                    React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-gray'] },
                        renderAvatar(avatar),
                        React.createElement("div", { className: "text-container" },
                            React.createElement("span", { className: "text-ellipsis" }, staffName),
                            React.createElement("span", { className: "text-static approve-content-wrapper-content flex-s-0 ml-4" }, msg)))),
                React.createElement("div", { className: "mt-8 flex-1" },
                    React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-radius-4'] + " " + styles['flow-log-action-wrapper-gray'] },
                        React.createElement("div", { className: "dis-f fd-c flex-1" },
                            payMethod ? (React.createElement("div", { className: "approve-content-wrapper-content-caption" }, i18n.get('方式') + "\uFF1A" + payMethod)) : null,
                            account ? (React.createElement("div", { className: "approve-content-wrapper-content-caption" }, i18n.get('账户') + "\uFF1A" + account)) : null,
                            React.createElement(PayeeInfoPopover, { paymentInfos: item.attributes.paymentInfos, showCode: true },
                                React.createElement("div", { className: "approve-content-wrapper-content-payInfo" }, i18n.get('查看收款信息'))))))));
            return { content: content };
        },
        render: function (_a) {
            var item = _a.item, config = _a.config;
            var _b = item.attributes, comment = _b.comment, autographImageId = _b.autographImageId;
            var content = this.approveContent({ item: item }).content;
            return (React.createElement("div", { className: styles['content-wrapper'] },
                renderApproveContent({ content: content }),
                comment && React.createElement("div", { className: styles['content-msg'] + " translate-ignore-class" }, comment),
                !!(autographImageId === null || autographImageId === void 0 ? void 0 : autographImageId.url) && React.createElement(AutographImage, { autographImageId: autographImageId }),
                React.createElement(ConditionApporveTipView, { node: config === null || config === void 0 ? void 0 : config.node })));
        }
    },
    'pay.partial.success': {
        approveContent: function (_a) {
            var _b;
            var item = _a.item;
            var _c = item.attributes, accountCompany = _c.accountCompany, paymentChannel = _c.paymentChannel, dynamicChannelMap = item.dynamicChannelMap;
            var avatar = get(item, 'operatorId.avatar');
            var payName = accountCompany ? accountCompany === null || accountCompany === void 0 ? void 0 : accountCompany.name : i18n.get('无');
            var name = getNameWithoutDelegate(item);
            var payChannel = ((_b = dynamicChannelMap === null || dynamicChannelMap === void 0 ? void 0 : dynamicChannelMap[paymentChannel]) === null || _b === void 0 ? void 0 : _b.name) || i18n.get('无');
            var msg = i18n.get('部分支付成功');
            var payMethod = i18n.get(payChannel);
            var account = i18n.get(payName);
            var staffName = getStaffName(item).staffName;
            var content = (React.createElement("div", { className: "dis-f fd-c flex-1" },
                React.createElement(Tooltip, { placement: 'bottom', title: formatToolTipContent(name, msg) },
                    React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-gray'] },
                        renderAvatar(avatar),
                        React.createElement("div", { className: "text-container" },
                            React.createElement("span", { className: "text-ellipsis" }, staffName),
                            React.createElement("span", { className: "text-static approve-content-wrapper-content flex-s-0 ml-4" }, msg)))),
                React.createElement("div", { className: "mt-8 flex-1" },
                    React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-radius-4'] + " " + styles['flow-log-action-wrapper-gray'] },
                        React.createElement("div", { className: "dis-f fd-c flex-1" },
                            payMethod ? (React.createElement("div", { className: "approve-content-wrapper-content-caption" }, i18n.get('方式') + "\uFF1A" + payMethod)) : null,
                            account ? (React.createElement("div", { className: "approve-content-wrapper-content-caption" }, i18n.get('账户') + "\uFF1A" + account)) : null,
                            React.createElement(PayeeInfoPopover, { paymentInfos: item.attributes.paymentInfos, showCode: true },
                                React.createElement("div", { className: "approve-content-wrapper-content-payInfo" }, i18n.get('查看收款信息'))))))));
            return { content: content };
        },
        render: function (_a) {
            var item = _a.item, config = _a.config;
            var _b = item.attributes, comment = _b.comment, autographImageId = _b.autographImageId;
            var content = this.approveContent({ item: item }).content;
            return (React.createElement("div", { className: styles['content-wrapper'] },
                renderApproveContent({ content: content }),
                comment && React.createElement("div", { className: styles['content-msg'] + " translate-ignore-class" }, comment),
                !!(autographImageId === null || autographImageId === void 0 ? void 0 : autographImageId.url) && React.createElement(AutographImage, { autographImageId: autographImageId }),
                React.createElement(ConditionApporveTipView, { node: config === null || config === void 0 ? void 0 : config.node })));
        }
    },
    'pay.partial.failure': {
        approveContent: function (_a) {
            var item = _a.item;
            var failureReason = item.attributes.failureReason;
            var name = getNameWithoutDelegate(item);
            var avatar = get(item, 'operatorId.avatar');
            var staffName = getStaffName(item).staffName;
            var content = (React.createElement("div", { className: "dis-f fd-c flex-1" },
                React.createElement(Tooltip, { placement: 'bottom', title: formatToolTipContent(name, i18n.get('部分支付失败')) },
                    React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-red'] },
                        renderAvatar(avatar),
                        React.createElement("div", { className: "text-container" },
                            React.createElement("span", { className: "text-ellipsis" }, staffName),
                            React.createElement("span", { className: "text-static approve-content-wrapper-content-reject ml-4" }, i18n.get('部分支付失败'))))),
                React.createElement("div", { className: "mt-8 flex-1" },
                    React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-radius-4'] + " " + styles['flow-log-action-wrapper-gray'] },
                        React.createElement("div", { className: "dis-f fd-c flex-1" },
                            React.createElement("div", { className: "approve-content-wrapper-content-caption" }, failureReason),
                            React.createElement(PayeeInfoPopover, { paymentInfos: item.attributes.paymentInfos, showCode: true, showFailureReason: true },
                                React.createElement("div", { className: "approve-content-wrapper-content-payInfo" }, i18n.get('查看收款信息'))))))));
            return { content: content };
        },
        render: function (_a) {
            var item = _a.item, config = _a.config;
            var _b = item.attributes, comment = _b.comment, autographImageId = _b.autographImageId;
            var content = this.approveContent({ item: item }).content;
            return (React.createElement("div", { className: styles['content-wrapper'] },
                renderApproveContent({ content: content }),
                comment && React.createElement("div", { className: styles['content-msg'] + " translate-ignore-class" }, comment),
                !!(autographImageId === null || autographImageId === void 0 ? void 0 : autographImageId.url) && React.createElement(AutographImage, { autographImageId: autographImageId }),
                React.createElement(ConditionApporveTipView, { node: config === null || config === void 0 ? void 0 : config.node })));
        }
    },
    'admin.skipnode': {
        approveContent: function (_a) {
            var _b, _c;
            var item = _a.item;
            var name = fnGetName(item);
            var avatar = get(item, 'operatorId.avatar');
            var nodeName = ((_b = item === null || item === void 0 ? void 0 : item.attributes) === null || _b === void 0 ? void 0 : _b.nodeName) || ((_c = item === null || item === void 0 ? void 0 : item.attributes) === null || _c === void 0 ? void 0 : _c.name);
            var msg = nodeName ? (React.createElement(React.Fragment, null,
                name,
                " ",
                i18n.get('设置跳过'),
                " ",
                nodeName)) : (name);
            var toolTipTitle = '';
            if (needTipContent(name) || needTipContent(item.attributes.name)) {
                toolTipTitle = msg;
            }
            var _d = getStaffName(item), staffName = _d.staffName, byDelegateName = _d.byDelegateName;
            var content = (React.createElement("div", { className: "dis-f fd-c flex-1" },
                React.createElement(Tooltip, { placement: 'bottom', title: toolTipTitle },
                    React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-info-content'] },
                        renderAvatar(avatar),
                        React.createElement("div", { className: "text-container" },
                            React.createElement(StaffNameComponent, { staffName: staffName, byDelegateName: byDelegateName, actionClassName: 'approve-content-wrapper-content-info' }),
                            React.createElement("span", { className: "text-static approve-content-wrapper-content-info ml-4" }, i18n.get('设置跳过')),
                            nodeName ? (React.createElement("span", { className: "text-ellipsis approve-content-wrapper-content ml-4" }, nodeName)) : null))),
                React.createElement("div", { className: "mt-8 flex-1" },
                    React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-radius-4'] + " " + styles['flow-log-action-wrapper-gray'] + " " + styles['flow-log-action-wrapper-gray-text'] }, i18n.get("\u539F\u56E0\uFF1A\u7BA1\u7406\u5458({__k0})\u624B\u52A8\u8DF3\u8FC7", { __k0: name })))));
            return { content: content };
        },
        render: function (_a) {
            var item = _a.item, userInfo = _a.userInfo, config = _a.config;
            var attachments = item.attachments, _b = item.attributes, comment = _b.comment, autographImageId = _b.autographImageId;
            var hasAttachments = attachments && attachments.length > 0;
            var content = this.approveContent({ item: item }).content;
            var atDom = addAtHighlighter(item, userInfo).atDom;
            return (React.createElement("div", { className: styles['content-wrapper'] },
                renderApproveContent({ content: content }, atDom),
                comment && React.createElement("div", { className: styles['content-msg'] + " translate-ignore-class" }, renderComment(item)),
                React.createElement("div", { className: "dis-f" },
                    hasAttachments && renderAttachments(attachments),
                    !!(autographImageId === null || autographImageId === void 0 ? void 0 : autographImageId.url) && React.createElement(AutographImage, { autographImageId: autographImageId }),
                    React.createElement(ConditionApporveTipView, { node: config === null || config === void 0 ? void 0 : config.node }))));
        }
    },
    'current-approving': {
        approveContent: function (_a) {
            var item = _a.item, config = _a.config, billInfo = _a.billInfo;
            var node = item.node;
            var name = fnGetName(item);
            var _b = getStaffName(item), staffName = _b.staffName, byDelegateName = _b.byDelegateName;
            var avatar = get(item, 'operatorId.avatar');
            var approvingCounterSingers = [];
            if ((node === null || node === void 0 ? void 0 : node.type) === 'countersign') {
                approvingCounterSingers = node.counterSigners.filter(function (counterSigner) {
                    return counterSigner.state === 'APPROVING';
                });
            }
            if ((node === null || node === void 0 ? void 0 : node.type) === 'ebot' || (node === null || node === void 0 ? void 0 : node.type) === 'invoicingApplication' || (node === null || node === void 0 ? void 0 : node.type) === 'recalculate') {
                avatar = 'EBotIconNode';
                name = EBotName;
                staffName = name;
            }
            if (isAIAgentNode(item)) {
                var agent = getAIAgentObj(item.node, config.nodesAIAgentMap).agent;
                avatar = agent === null || agent === void 0 ? void 0 : agent.icon;
                name = agent === null || agent === void 0 ? void 0 : agent.name;
                staffName = name;
            }
            var content = '';
            if ((node === null || node === void 0 ? void 0 : node.type) === 'countersign') {
                var msg = i18n.get('{__k0}名成员', { __k0: approvingCounterSingers.length });
                content = (React.createElement(CountersignTooltip, { showLogView: true, onlyShowProcessing: true, placement: 'bottom', node: node, flowLogs: (config === null || config === void 0 ? void 0 : config.flowLogs) || [], staffDisplayConfigField: flowStateMap.staffDisplayConfigField, component: React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-info'] + " cur-p" },
                        React.createElement("div", { className: styles['user-icon'] },
                            React.createElement(FilledGeneralRecord, { fontSize: 12, color: 'var(--eui-bg-body)' })),
                        React.createElement("div", { className: "text-container" },
                            React.createElement("span", { className: "text-ellipsis" }, msg),
                            React.createElement("span", { className: "text-static approve-content-wrapper-content-approving ml-4" }, i18n.get('正在处理') + "..."))) }));
            }
            else {
                var msg = i18n.get('正在处理') + "...";
                content = (React.createElement(Tooltip, { placement: 'bottom', title: formatToolTipContent(name, msg) },
                    React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-info'] },
                        renderAvatar(avatar),
                        React.createElement("div", { className: "text-container" },
                            React.createElement(StaffNameComponent, { staffName: staffName, byDelegateName: byDelegateName, actionClassName: 'approve-content-wrapper-content-approving' }),
                            React.createElement("span", { className: "text-static approve-content-wrapper-content-approving ml-4" }, msg)))));
            }
            return { content: content };
        },
        render: function (_a) {
            var item = _a.item, config = _a.config, billInfo = _a.billInfo;
            var content = this.approveContent({ item: item, config: config, billInfo: billInfo }).content;
            return (React.createElement("div", { className: styles['content-wrapper'] },
                renderApproveContent({ content: content }),
                React.createElement("div", { className: "dis-f" },
                    React.createElement(ConditionApporveTipView, { node: config === null || config === void 0 ? void 0 : config.node }))));
        }
    },
    feature: {
        render: function (_a) {
            var item = _a.item, config = _a.config, staffMap = _a.staffMap;
            var node = item.node, isEditConfig = item.isEditConfig;
            var name = fnGetName(item);
            var staffName = getStaffName(item).staffName;
            var fullName = name;
            var avatar = get(item, 'operatorId.avatar');
            var msg = i18n.get('等待处理');
            var useCountersignTooltip = false;
            var isSubmitterChoice = get(node, 'config.isSubmitterChoice');
            var isAuto = get(node, 'config.isAuto');
            var isEdit = false;
            if (!isSubmitterChoice &&
                !isAuto &&
                isEditConfig &&
                !['ebot', 'recalculate', 'invoicingApplication', 'aiApproval'].includes(node === null || node === void 0 ? void 0 : node.type)) {
                isEdit = true;
            }
            var noApprover = false;
            if ((node === null || node === void 0 ? void 0 : node.type) === 'countersign') {
                var approvingCounterSingers = [];
                if ((node === null || node === void 0 ? void 0 : node.policy) === 'ANY') {
                    approvingCounterSingers = node.counterSigners;
                }
                else {
                    approvingCounterSingers = node.counterSigners.filter(function (counterSigner) {
                        return counterSigner.state === 'APPROVING' || counterSigner.action === 'freeflow.reject';
                    });
                }
                useCountersignTooltip = true;
                name = approvingCounterSingers.length + "\u540D\u6210\u5458";
                staffName = name;
                fullName = approvingCounterSingers
                    .map(function (counterSigner) { return fnGetName({ operatorId: counterSigner.signerId }); })
                    .join('、');
            }
            else if (!node.approverId) {
                name = isEdit ? i18n.get('选择审批人') : i18n.get('暂无审批人');
                staffName = name;
                noApprover = true;
                fullName = '';
            }
            var tipMsg = msg;
            var avatarIconClass = '';
            var paySkippedTypes = [
                'PAY_AMOUNT_IS_0',
                'NO_ABILITY',
                'REQUISITION_NO_ABILITY',
                'NO_ABILITY_TRUE',
                'NO_ABILITY_FALSE'
            ];
            if (paySkippedTypes.includes(node === null || node === void 0 ? void 0 : node.skippedType)) {
                avatar = 'EBotIconNode';
                msg = i18n.get('将自动跳过');
                fullName = i18n.get('单据无需支付');
                name = EBotName;
                staffName = name;
                tipMsg = '';
                isEdit = false;
                avatarIconClass = styles['usr-icon-neu-300'];
            }
            if ((node === null || node === void 0 ? void 0 : node.type) === 'ebot' || (node === null || node === void 0 ? void 0 : node.type) === 'invoicingApplication' || (node === null || node === void 0 ? void 0 : node.type) === 'recalculate') {
                avatar = 'EBotIconNode';
                name = EBotName;
                staffName = name;
                isEdit = false;
                avatarIconClass = styles['usr-icon-neu-300'];
            }
            if ((node === null || node === void 0 ? void 0 : node.type) === 'aiApproval') {
                var agent = getAIAgentObj(node, config.nodesAIAgentMap).agent;
                avatar = agent === null || agent === void 0 ? void 0 : agent.icon;
                name = agent === null || agent === void 0 ? void 0 : agent.name;
                staffName = name;
                isEdit = false;
            }
            var skippedTypes = [
                'NO_SKIPPED_TRUE',
                'NO_SKIPPED_FALSE',
                'APPROVER_NOT_FOUND_BY_ROLE',
                'APPROVER_SAME_AS_SUBMITTER_BY_ROLE',
                'APPROVER_NOT_FOUND',
                'NO_AUTO_AGREE',
                'APPROVER_SAME_AS_SUBMITTER',
                'APPROVER_REPEATED',
                'APPROVER_SAME_AS_OWNER'
            ];
            if (skippedTypes.includes(node === null || node === void 0 ? void 0 : node.skippedType)) {
                avatar = 'EBotIconNode';
                msg = i18n.get('将自动跳过');
                name = EBotName;
                staffName = name;
                tipMsg = '';
                isEdit = false;
                avatarIconClass = styles['usr-icon-neu-300'];
                fullName = skipTypeMap()[node === null || node === void 0 ? void 0 : node.skippedType];
            }
            var customStaffs;
            var customDesc;
            if ((node === null || node === void 0 ? void 0 : node.type) === 'carbonCopy') {
                var ccStaffIds = get(node, 'carbonCopy[0].staffIds', []);
                customStaffs = ccStaffIds.map(function (staffId) {
                    return { signer: staffMap[staffId] };
                });
                customDesc = i18n.get('抄送至{__k0}名人员', { __k0: customStaffs.length });
                if (customStaffs.length > 1) {
                    useCountersignTooltip = true;
                    staffName = i18n.get('将抄送单据给');
                    msg = i18n.get('{__k0}名成员', { __k0: customStaffs.length });
                }
                else if (customStaffs.length === 1) {
                    useCountersignTooltip = false;
                    staffName = i18n.get('将抄送单据给');
                    fullName = staffName;
                    tipMsg = fnGetName(item, staffMap[ccStaffIds[0]]);
                    msg = getStaffName(item, staffMap[ccStaffIds[0]]).staffName;
                }
                else {
                    useCountersignTooltip = false;
                    msg = i18n.get('将自动跳过');
                    staffName = i18n.get('匹配不到抄送人');
                }
                avatar = 'CarbonCopyIconNode';
                isEdit = false;
            }
            var handleModifiedStaff = function () {
                if (!isEdit) {
                    return;
                }
                config.onModifiedStaff && config.onModifiedStaff(node);
            };
            var className = '';
            var canModifyUserClassName = '';
            if (isEdit) {
                className = noApprover
                    ? 'text-ellipsis-select text-ellipsis-no-select-hover'
                    : 'text-ellipsis-disabled text-ellipsis-select-hover';
                canModifyUserClassName = styles['flow-log-action-wrapper-feature-content'];
            }
            else {
                className = 'text-ellipsis-disabled';
            }
            if (!(avatar === null || avatar === void 0 ? void 0 : avatar.length)) {
                avatarIconClass = styles['usr-icon-neu-300'];
            }
            var tooltipContent = (React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-feature'] + " " + canModifyUserClassName },
                renderAvatar(avatar, avatarIconClass),
                React.createElement("div", { className: "text-container" },
                    React.createElement("span", { className: classNames('text-ellipsis', className), onClick: handleModifiedStaff }, staffName),
                    React.createElement("span", { className: "text-static approve-content-wrapper-content-disabled ml-4" }, msg))));
            var baseTooltip = (React.createElement(Tooltip, { placement: 'bottom', title: formatToolTipContent(fullName, tipMsg) }, tooltipContent));
            var countersignTooltip = (React.createElement(CountersignTooltip, { showLogView: true, onlyShowProcessing: true, placement: 'bottom', node: node, flowLogs: (config === null || config === void 0 ? void 0 : config.flowLogs) || [], staffDisplayConfigField: flowStateMap.staffDisplayConfigField, component: tooltipContent, customStaffs: customStaffs, customDesc: customDesc }));
            var content = useCountersignTooltip ? countersignTooltip : baseTooltip;
            return (React.createElement("div", { className: styles['content-wrapper'] },
                renderApproveContent({ content: content }),
                React.createElement("div", { className: "dis-f" },
                    React.createElement(ConditionApporveTipView, { node: config === null || config === void 0 ? void 0 : config.node }))));
        }
    }
};
function renderExpress(type) {
    return {
        approveContent: function (_a) {
            var item = _a.item;
            var name = fnGetName(item);
            var avatar = get(item, 'operatorId.avatar');
            var content = '';
            var _b = getStaffName(item), staffName = _b.staffName, byDelegateName = _b.byDelegateName;
            if (type === 'receive') {
                content = (React.createElement(Tooltip, { placement: 'bottom', title: formatToolTipContent(name, i18n.get('确认收单')) },
                    React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-green'] },
                        renderAvatar(avatar),
                        React.createElement("div", { className: "text-container" },
                            React.createElement(StaffNameComponent, { staffName: staffName, byDelegateName: byDelegateName, actionClassName: 'approve-content-wrapper-content-green' }),
                            React.createElement("span", { className: "text-static approve-content-wrapper-content-green ml-4" }, i18n.get('确认收单'))))));
            }
            else if (type === 'receiveExcep') {
                content = (React.createElement(Tooltip, { placement: 'bottom', title: formatToolTipContent(name, i18n.get('收单异常')) },
                    React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + styles['flow-log-action-wrapper-red'] },
                        renderAvatar(avatar),
                        React.createElement("div", { className: "text-container" },
                            React.createElement(StaffNameComponent, { staffName: staffName, byDelegateName: byDelegateName, actionClassName: 'approve-content-wrapper-content-reject' }),
                            React.createElement("span", { className: "text-static approve-content-wrapper-content-reject ml-4" }, i18n.get('收单异常'))))));
            }
            else {
                var msg = '';
                var className = styles['flow-log-action-wrapper-gray'];
                var contentClassName = 'approve-content-wrapper-content';
                var actionClassName = 'approve-content-wrapper-content';
                if (type === 'cancelReceiveExcep') {
                    msg = i18n.get('取消收单异常');
                }
                else if (item.attributes.expressNum) {
                    className = styles['flow-log-action-wrapper-info-content'];
                    contentClassName = 'approve-content-wrapper-content-info';
                    actionClassName = 'approve-content-wrapper-content-info';
                    msg = i18n.get('寄送了单据');
                }
                else {
                    msg = i18n.get('跳过了寄送');
                }
                content = (React.createElement(Tooltip, { placement: 'bottom', title: formatToolTipContent(name, msg) },
                    React.createElement("div", { className: styles['flow-log-action-wrapper'] + " " + className },
                        renderAvatar(avatar),
                        React.createElement("div", { className: "text-container" },
                            React.createElement(StaffNameComponent, { staffName: staffName, byDelegateName: byDelegateName, actionClassName: contentClassName }),
                            React.createElement("span", { className: "text-static " + actionClassName + " ml-4" }, msg)))));
            }
            return { content: content };
        },
        render: function (_a) {
            var item = _a.item, userInfo = _a.userInfo, config = _a.config;
            var attachments = item.attachments, _b = item.attributes, comment = _b.comment, autographImageId = _b.autographImageId;
            var hasAttachments = attachments && attachments.length > 0;
            var content = this.approveContent({ item: item }).content;
            var _c = addAtHighlighter(item, userInfo), atDom = _c.atDom, highlighterKey = _c.highlighterWords, commentContent = _c.content;
            var _comment = comment;
            if (comment === i18n.get('收单异常') || comment === i18n.get('取消收单异常')) {
                _comment = '';
            }
            return (React.createElement("div", { className: styles['content-wrapper'] },
                renderApproveContent({ content: content }, atDom),
                _comment && (React.createElement("div", { className: styles['content-msg'] + " translate-ignore-class" },
                    React.createElement(Highlighter, { highlightClassName: styles['highlight'], searchWords: highlighterKey, textToHighlight: commentContent }))),
                React.createElement("div", { className: "dis-f" },
                    hasAttachments && renderAttachments(attachments),
                    !!(autographImageId === null || autographImageId === void 0 ? void 0 : autographImageId.url) && React.createElement(AutographImage, { autographImageId: autographImageId }),
                    React.createElement(ConditionApporveTipView, { node: config === null || config === void 0 ? void 0 : config.node }))));
        }
    };
}
var fnMapLogs = function (logs) {
    var flowLogs = [];
    logs.forEach(function (item, index) {
        flowLogs.push(__assign(__assign({}, item), { index: index }));
        var modifyFlowLog = item.modifyFlowLog;
        if (modifyFlowLog) {
            lastVersionNum = modifyFlowLog.length ? modifyFlowLog[modifyFlowLog.length - 1].version : 0;
            var mLogs = modifyFlowLog
                .filter(function (item) { return item.operatorState !== ModifyCreateType; })
                .map(function (line) {
                var _a;
                var operatorMap = {
                    openapi: { name: 'OpenAPI' },
                    '320-corporateReceipt': { name: i18n.get('收款业务'), id: '320-corporateReceipt' }
                };
                var operatorState = line.operatorState;
                if (line.operatorId === '320-corporateReceipt' && line.operatorState === 'REPLENISH_INVOICE') {
                    operatorState = 'REPLENISH_INVOICE_AUTO';
                }
                return __assign(__assign({}, line), { time: line.operatorTime, action: ModifyBillAction, attributes: { comment: line.editeReason }, operatorState: operatorState, operatorId: (_a = operatorMap[line.operatorId]) !== null && _a !== void 0 ? _a : line.operatorId });
            });
            flowLogs = flowLogs.concat(mLogs);
        }
    });
    return flowLogs;
};
var needTipContent = function (content) {
    if (!content) {
        return false;
    }
    if (window.isInWeComISV) {
        return true;
    }
    return content.length > 4;
};
var formatToolTipContent = function (name, action) {
    if (name === void 0) { name = ''; }
    if (action === void 0) { action = ''; }
    return needTipContent(name) ? (React.createElement(React.Fragment, null,
        name,
        " ",
        action)) : ('');
};
function parseReg(items) {
    if (items === void 0) { items = []; }
    return items.map(function (item) {
        return formatRegStr(item);
    });
}
function fnGetOperatorStateStr(operatorState) {
    var content = '';
    var className = '';
    var showVersion = true;
    var wrapperClassName = styles['flow-log-action-wrapper-info'];
    switch (operatorState) {
        case 'REPLENISH_INVOICE':
            content = i18n.get('补充了发票');
            wrapperClassName = styles['flow-log-action-wrapper-feature'];
            className = 'approve-content-wrapper-content';
            break;
        case 'REPLENISH_INVOICE_AUTO':
            content = i18n.get('自动补充了发票');
            wrapperClassName = styles['flow-log-action-wrapper-feature'];
            className = 'approve-content-wrapper-content';
            break;
        case 'CONFIRM_INVOICE':
            content = i18n.get('确认了发票');
            wrapperClassName = styles['flow-log-action-wrapper-feature'];
            className = 'approve-content-wrapper-content';
            break;
        case 'DELETE_INVOICE':
            content = i18n.get('删除了发票');
            wrapperClassName = styles['flow-log-action-wrapper-feature'];
            className = 'approve-content-wrapper-content';
            break;
        default:
            content = i18n.get('修改了单据');
            className = 'approve-content-wrapper-content-info';
            wrapperClassName = styles['flow-log-action-wrapper-info-content'];
            break;
    }
    return { content: content, className: className, showVersion: showVersion, wrapperClassName: wrapperClassName };
}
var StaffNameComponent = function (_a) {
    var staffName = _a.staffName, byDelegateName = _a.byDelegateName, _b = _a.actionClassName, actionClassName = _b === void 0 ? '' : _b;
    if (staffName === EBotName) {
        return React.createElement("span", { className: "text-ellipsis" }, staffName);
    }
    return (React.createElement(React.Fragment, null,
        byDelegateName ? React.createElement("span", { className: "text-ellipsis" }, byDelegateName) : null,
        byDelegateName ? React.createElement("span", { className: "text-static " + actionClassName + " ml-4 mr-4" }, i18n.get('代')) : null,
        React.createElement("span", { className: "text-ellipsis" }, staffName)));
};
function fnSubstr16(str) {
    if (str.length > 16) {
        return str.substring(0, 16) + '...';
    }
    return str;
}
export { fnMapLogs, flowStateMap, formatAttachments, fnSubstr16, addAtHighlighter };
